
import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
import { Prop, Watch } from 'vue-property-decorator';
import { ImagePlayer, audioPlayer, backgroundAudioPlayer, captionsPlayer } from '@/views/videoEditor/utils/imgPlayer';
import GeneratePicture from '../generatePicture/generatePicture'
import TextTemplate from '../textTemplate/textTemplate'
import Subtitles from '../subtitles/subtitles'
import ShortPlayer from '../shortPlayer/shortPlayer'
import Axios from 'axios';
import screenPlayer from '../screenPlayer/screenPlayer'
import { TabBarListTypeMap, WHRATIO,TabTypeMap,TRANSTIME,GPWHRATIO, DEFAULTFONTSIZE } from '../../utils/constant';
import { toast } from '@/utils/util'
import { judgeDeviceType } from '@/utils/device';
import exportPopup from '../exportPopup/exportPopup'
import ProjectHistory from '@/views/videoEditor/utils/history'
import CoverPicker from '../coverPicker/coverPicker';
import { bgaToColor, colorTobga, compareObjects, debouncedSaveArticle, domToUrl, changeUrl2Cdn } from '../../utils/utils';
import ImgTrack from '../imgTrack/imgTrack';
import LoadingWrapper from '../loading/loading.vue';
import { debounce } from 'lodash-es';
import { getSrtParamsStyleByArticleId } from '../../utils/srtParamsStyle';
import { getQueryString } from '@/utils/location';
import Konva from 'konva';
import { VFX } from '../../utils/vfx';
import { SegmentPlayer } from '../../utils/segmentPlayer';
import * as Diff from 'diff';
import to from 'await-to-js';
import { stepApiMonitor } from '@/utils/stat';
import { DecompressPlayer } from '../../utils/DecompressPlayer';

type selectType = 'text' | 'textTemplate' | 'img' | 'speakerAudio' | 'backAudio';
type myselect = {
	type: selectType,
	selectIndex: number
}
/**components**/
@Component({
	components: {
		GeneratePicture,
		TextTemplate,
		Subtitles,
		ShortPlayer,
		screenPlayer,
		exportPopup,
		CoverPicker,
		ImgTrack,
		LoadingWrapper
	}
})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class Player extends Vue {
	playerContainerHeight: number = 7.2;
	scaleRatio = 16 / 9
	canvasWidth: number = 4.04 / 7.5 * window.innerWidth
	canvasHeight: number = this.canvasWidth * 16/9;
	isIOS = judgeDeviceType.isIOS
	state = new PageState();
	isScreen = false
	currPlayTime = 0; // 播放的当前时间，跟音频currentTime同步。1.音频timeupdate会实时更新 2.手动seek时，调整此值
	isJsScroll = false; // 是否是js调用的滚动，js调用的滚动不会触发滚动事件里的seek时间
	// stopUpdateCanvasOnScrollTrack = false; // 是否阻止滚动防抖函数中更新画布内容
	audioDuration = null; // 音频时长
	videoDuration = null; // 视频时长，取自后端数据endTime，编辑器由音频timeupdate驱动渲染，优先使用audioDuration
	curImg = '';
	animationTypeList = ["PullInUp", "PullInDown", "PullInLeft", "PullInRight", "ZoomIn", "ZommInX", "ZoomInY", "SlideInUp", "SlideInDown", "SlideInLeft", "SlideInRight", "PressInUp", "PressInDown", "PressInLeft", "PressInRight", "PressInX", "PressInY", "UncoverFromTop", "UncoverFromBottom", "ShutterX", "ShutterY", "ZoomFullScreen", "Wheel", "Tooth", "FadeIn", "FadeOut", "StackInTop", "StackInBottom", "StackInLeft", "StackInRight", "TopLaser", "BottomLaser", "RightLaser", "LeftLaser"]

	curSelect: myselect = {
		type: 'text',
		selectIndex: -1
	}
	renderEle = {
		imgUrl: this.curImg,
		text: '',
		imageId: '',
	}
	isPlay = false;
	textToImg = {}
	imgCoverUrl = '';
	// 默认封面
	defaultCoverUrl = '';
	textList = [];
	extraTextMap = {};
	imgList = []
	// 特效合集
	specialEffectList = []
	curSpeakerAudio = {
		audioUrl: 'https://mobvoi-speech-public.mobvoi.com/mobvoi-tts/voice-maker/synthesis_audio/43172374/1703051675388/d4b0d4a9ec990a21d1492d38dfdbc760.wav',
		speakerName: '魔云熙',
		speaker: '',
		style: '悲伤',
		startTime: 0,
		endTime: 48,
		speed: '1.0',
	}
	backAudio = {
		audioUrl: '',
		audioName: '',
		duration: 158,
	}
	promptResult = []
	isGreenScreen = false // 是否是绿幕
	isShowExportPopup = false
	isShowGeneratePickture = false // 是否显示合成图片
	isEdit = false // 是否显示编辑框
	renderEleIndex = 0 // 当前索引
	saveProjectInit = true
	projectHistory: ProjectHistory
	taskId = null
	fps = 24
	articleId: any = ''
	isCanReAudio = false
	canUndo = false
	canRedo = false;
  isApp = judgeDeviceType.isAPP;
  orginalImgList: any = []
	showCover = false
	coverMaterialList = []
	currentItem: any = {}
	showloading = false
	bgVolume = 0
	vipInfo = {}
	isShortPlay = false // 是否是短剧
	isDownStress = false // 是否为解压视频
	shortPlayTaskParam = {} // 短剧更新参数，用作比较，减少不必要的更新
	shortCut = { segments: [], height: 1920, style: '' } // 短剧的数据，用于提交
	segmentsList = [] // 短剧播放数据（处理后的），用于timeSegmentPlayer
	shortPlayerStyle = {} // 短剧容器样式
	timeSegmentPlayer = null
	timeDecompressPlayer: DecompressPlayer = null
	shortDuration = 0; // 短剧时长
	blurList = [] // 短剧高斯模糊
	renderBlurTime = 0; // 高斯模糊渲染时间
	fontsizeRatio = 1; // 字幕大小比例
	uuidSelectedText = '' // 短剧选中的文本uuid
	isOncePlay = false; // 是否曾经播放过，用于某些iOS首次触发播放
	wexinLoading = false; // 微信端进行loading

	ttsWordVOList = []
	_scrollCurIndex = 0
	created(moduleData: IinjectDatas) {
    console.log('player created')
		this.state = <PageState>moduleData.state;
		if (this.$route.query.articleId) {
			this.articleId = this.$route.query.articleId
			sessionStorage.setItem('articleId', this.articleId)
		}
		this.projectHistory = new ProjectHistory(this.listenProject)
		this.projectHistory.removeAllProjectDataFromStorage()
		let query: any = this.$route.query
		if (query.bgUrl) {
			let articleId = sessionStorage.getItem('articleId')
			let taskId = sessionStorage.getItem('taskId')
			this.taskId = taskId; this.articleId = articleId;
			let bgUrl2 = decodeURIComponent(query.bgUrl)
			this.backAudio = {
				audioUrl: bgUrl2,
				audioName: query.bgName,
				duration: query.duration,
			}
			// this.renderAllData()
		}
		this.$bus.$on('add-text-track', this.handleAddTextTrack)
	}
	mounted() {
		(window as any).stopAppAudio = this.stopAudio;
		let query: any = this.$route.query
		this.showloading = true
		if (query.bgmUrl) {
			this.backAudio = {
				audioUrl: query.bgmUrl,
				audioName: query.bgmName,
				duration: query.duration,
			}
		}
		const resourceType = Number(query.resourceType);
		if (resourceType === 2 || resourceType === 3 || resourceType === 4) {  // 2短剧引流 3商单-影视短剧
			this.isShortPlay = true
			if(judgeDeviceType.isWxBrowser || window.WeixinJSBridge) {
				console.log('wexinLoading---')
				this.wexinLoading = true;
			}
			document.addEventListener("WeixinJSBridgeReady",
				() => {
					console.log("WeixinJSBridgeReady------")
					this.wexinLoading = false;
					this.timeSegmentPlayer?.tryPlayFirstVideo();
					this.timeDecompressPlayer?.tryPlayFirstVideo();
					this.isOncePlay = true;
				},
				false
			);
		} else if (resourceType === 51) {
			this.isDownStress = true
		}
		this.initBackAudio()
		this.initRequest()
		// this.initPlayer()
		this.initListener()
		this.$bus.$on('canvasPuase', () => {
			this.startAudioPlay(false)
		})
    this.$bus.$on(this.$EventBusKey.SELECT_TEXT_TEMPLATE, this.changeTextTemplateEditState)
		this.$nextTick(() => {
			this.initTrackDivideHeight()
		})
	}
	initTrackDivideHeight() {
		const trackContainer = this.$refs.trackContainer as HTMLElement;
		const trackdivideRef = this.$refs.trackdivideRef as HTMLElement;
		trackdivideRef.style.height = trackContainer.clientHeight + 'px';
	}
	get isHideBgMusic() {
		if(!this.isShortPlay) {
			this.state.isHideBgMusic = false;
			return false;
		}
		const hidebgMusicStyleArr = ['highlight_origin', 'splicing_topic', 'splicing_plot', 'golden_opening_without_explanation'];
		if(hidebgMusicStyleArr.indexOf(this.shortCut?.style) > -1) {
			this.state.isHideBgMusic = true;
			return true;
		}
		this.state.isHideBgMusic = false;
		return false;
	}
	get isPromtFocus() {
		return this.state.promtFocus
	}
	listenProject() {
		this.canUndo = this.projectHistory.canUndo()
		this.canRedo = this.projectHistory.canRedo()
	}
	getIosVersion() {
		var str = navigator.userAgent.toLowerCase()
		var ver = str.match(/cpu iphone os (.*?) like mac os/)
		return ver ? ver[1] : false
	  }
	  get isSupport(){
		let iosV = this.getIosVersion()
		let iosVNum: number = 0
		if (iosV) {
		  iosVNum = iosV.split('_').length > 2
			? parseInt(iosV.split('_').join(''))
			: parseInt(iosV.split('_').join('')) * 10
		}
		if (iosV && iosVNum < 1700) {
			return false
		}else{
			return true
		}
	}
	
	//初始化请求
	initRequest() {
		this.getCurPromptResult()
	}
	@Watch("$route")
	watchRouteParamChange() {
		let _self = this;
		let query: any = this.$route.query
		if (query.bgmUrl) {
			this.backAudio = {
				audioUrl: query.bgmUrl,
				audioName: query.bgmName,
				duration: query.duration,
			}
			this.initBackAudio()
			this.saveVideoPromot()
			this.saveProject()
		}
		//d3d3LmJhaWR1LmNvbQ%3D%3D
		// this.copyText = LZString.decompressFromBase64('d3d3LmJhaWR1LmNvbQ%3D%3D');
	}
	@Watch("isShowGeneratePickture")
	watchShowGeneratePickture(val){
		if(val){
			[this.canvasWidth, this.canvasHeight] = GPWHRATIO[this.scaleRatio].size
			this.playerContainerHeight=4.3
		}else{
			[this.canvasWidth, this.canvasHeight] = WHRATIO[this.scaleRatio].size
			this.playerContainerHeight=7.2
			this.initListener()
			this.$nextTick(() => {
				this.setTrackScrollOffsetByTime(); // 退出图片编辑，需要将轨道滚动到对应位置
			})
		}
	}
	@Watch("playerContainerHeight")
	watchPlayerContainerHeight(){
		// 修改了playerContainerHeight，需要重新渲染特效canvas宽高
		this.$nextTick(() => {
			this.vfx = new VFX(this.$refs.videoCanvasRef, this.specialEffectList)
		})
	}
	getCurPromptResult() {
		let path = 'createDefaultTask'
		if (this.isShortPlay) {
			path = 'createShortPlayDefaultTask'
		}
		this.$http(path, { articleId: this.articleId }).then(res => {
			if (res.code == 200) {
				if (this.isShortPlay) {
					this._handleShortPlay(res)
				} else if (this.isDownStress) {
					this.setDefaultDownStressFont()
					this._handleTextToImage(res)
				} else {
					this.state.subtitleInfo.fontFamily = 'TsangerShuYuanT W02' // 苍耳云舒
					this._handleTextToImage(res)
				}
			} else {
				toast('请求失败，请稍后再试')
			};
		}).catch(err => {
			console.log(err);
			toast('请求失败，请稍后再试')
		})
	}
	/**
	 * 处理短剧
	 * @param res
	 */
	_handleShortPlay(res) {
		const { taskId, promptResultVO, composeArticleVO, taskParam, coverUrl } = res.data
		this.taskId = taskId; // 任务id
		// 获取视频时长
		this.getVideoEndTime(promptResultVO?.shortCut?.segments || [])

		this.reShortPlayLineTrack(promptResultVO)
		// 由于背景音乐被删除，前端手动替换背景音乐域名为腾讯 CDN 地址
		const bgmUrl = this.replaceBgmUrl(taskParam.bgmUrl)
		// 背景音
		this.backAudio = {
			audioUrl:bgmUrl,
			audioName:taskParam.bgmName,
			duration:taskParam.bgmDuration,
		}
		if (this.backAudio.audioUrl) {
			this.initBackAudio();
		}
		const bgmVolume = Number(taskParam.bgmVolume || '0.1');
		this.changeBgVolume(bgmVolume * 100);
		this.$emit("update-bgVolume", bgmVolume);
		// 封面
		if (taskParam.coverMaterialList) {
			this.coverMaterialList = taskParam.coverMaterialList
		}

		// 模板参数
		if (taskParam.textTemplateList) {
			this.initTextTemplateList(taskParam.textTemplateList)
		}
	
		if (coverUrl) {
			this.imgCoverUrl = changeUrl2Cdn(coverUrl)
		}
		// 发音人回显
		const { speakerName, speakerStyle, speechSpeed } = composeArticleVO.extendVO;
		this.curSpeakerAudio.speakerName = speakerName;
		this.curSpeakerAudio.style = speakerStyle;
		this.curSpeakerAudio.speed = speechSpeed;

		this.renderEle ={
			imgUrl: this.imgCoverUrl,
			text: '',
			imageId: '',
		}
		this.shortPlayTaskParam = this.getShortPlayTaskParam();
		this.saveProject();
	}
	initTextTemplateList(_textTemplateList) {
		const textTemplateList = _textTemplateList.map(item => {
			if (item.fontSize === null) {
				item.fontSize = 14
			}
			if (item.opacity === null) {
				item.opacity = 0.92
			}
			if (item.fontFamily === null) {
				item.fontFamily = ''
			}
			return item
		})
		this.state.savedTextList = textTemplateList
		this.state.operatingTextList = textTemplateList
	}
	/**
	 * 设置解压默认相关配置
	 */
	setDefaultDownStressFont() {
		this.state.workType = 'down_stress'
		this.state.subtitleInfo.marginV = 0.5
		this.state.subtitleInfo.fontColour = '#000000'
		this.state.subtitleInfo.fontStrokeColor = '#ffffff'
		this.state.subtitleInfo.fontFamily = 'TsangerShuYuanT W02' // 苍耳云舒
	}
	handleDownStressData(list) {
		if (!list || !list.length) return
		const _list = JSON.parse(JSON.stringify(list))
		const text = _list[0].textList[0]
		const newList = text.split(' ')
		newList.forEach((item, index) => {
			_list[0].textList[index] = item
		})
		return _list
	}
	/**
	 * 处理解压轨道数据
	 * @param promptResultVO
	 */
	reDownStressPlayLineTrack(promptResultVO) {
		const promptImageInfo =  promptResultVO.promptImageVOList[0]
		const endTime = promptImageInfo.endTime
		
		// 设置比例
		if (promptImageInfo.width) {
			let scaleCode: any = 0
			Object.keys(WHRATIO).forEach(key => {
				const [width, height] = key.split(':');
				if (+width / +height === promptImageInfo.width / promptImageInfo.height) {
					scaleCode = key;
				}
			})
			if (scaleCode) {
				this.scaleRatio = scaleCode;
				[this.canvasWidth, this.canvasHeight] = WHRATIO[scaleCode].size
			}
			this.fontsizeRatio = promptImageInfo.height / 200;
		}
		// 给compressVideoList添加startTime和endTime参数
		promptImageInfo.compressVideoList.forEach((video, index) => {
			if (index > 0) {
				video.startTime = promptImageInfo.compressVideoList[index - 1].endTime
				if (index === promptImageInfo.compressVideoList.length - 1) {
					video.endTime = endTime / 1000
				} else {
					video.endTime = video.startTime + video.duration / 1000
				}
				
			} else {
				video.startTime = 0
				video.endTime = video.duration / 1000
			}
		})

		// 设置视频数据
		const segmentsList = promptImageInfo.compressVideoList
		console.log('reDownStressPlayLineTrack', segmentsList)
		segmentsList.forEach((segment, i) => {
			const { video } = segment
			segment.videoUrl = video
			segment.type = 'explanation' // 静音
			segment.width = promptImageInfo.width
			segment.height = promptImageInfo.height
			segment.video = {
				video_segment_oss_path: video
			}
		})

		this.segmentsList = segmentsList
		if (!this.timeDecompressPlayer) {
			this.$nextTick(() => {
				this.initDecompressPlay()
			})
		} else {
			this.curSpeakerAudio.audioUrl = promptResultVO.audioUrl
			this.timeDecompressPlayer.updateAudioUrl(promptResultVO.audioUrl)
		}

		// 处理文字轨道数据
		let promptImageVOList = promptResultVO.promptImageVOList
		let textList = []
		promptImageVOList = promptImageVOList.map(ele => {
			ele.textVOList.map((item, idx) => {
				const handleItem = item
				handleItem.startTime = handleItem.startTime / 1000
				handleItem.endTime = handleItem.endTime / 1000
				if (idx === ele.textVOList.length - 1) {
				  handleItem.isEnd = true
				}
				textList.push(handleItem)
				return handleItem
			})
		})
		this.updateTextList(textList, 0)


		// 处理图片轨道数据
		const imgList = []
		
		promptImageInfo.compressVideoList.forEach((video, idx) => {
			const imgs = video.thumbnails || []
			if (imgs) {
					let durationEachImg = 1; // 算法改为1s取一帧
					const durAllImg = video.endTime - video.startTime
					if(imgs.length * durationEachImg < durAllImg) {
						durationEachImg = Math.round(Math.ceil(durAllImg) / imgs.length); // 原来算法约2s取一帧
					}
					const lastEndTime = Math.ceil(endTime / 1000) - 1
					imgs.forEach((img, index) => {
						if ((video.startTime + durationEachImg * index) <= lastEndTime) {
							const imgItem = {
								startTime: video.startTime + durationEachImg * index,
								endTime: video.startTime + durationEachImg * (index + 1),
								imgUrl: img,
								thumbnailUrl: img,
							}
							if(index === imgs.length -1) {
								imgItem.endTime = video.endTime;
							}
							imgList.push(imgItem);
						}
					})
			}
		})
		if(imgList.length) imgList[0].startTime = 0.01; // 避免首帧图片点击后显示封面
		imgList[imgList.length - 1].endTime = endTime / 1000
		this.imgList = JSON.parse(JSON.stringify(imgList))

		let time = this.textList[this.textList.length - 1].endTime
		this.curSpeakerAudio.endTime = time
		this.curSpeakerAudio.startTime = 0
		this.videoDuration = time
		
	}
	/**
	 * 初始化解压视频播放器
	 */
	initDecompressPlay() {
		this.setShortPlayStyle()
		this.$nextTick(() => {
			this.widthEverySecond = this.getWidthEverySecond()
		})
		this.trackScrollLeft = 0
		this.timeDecompressPlayer = new DecompressPlayer({
			audioUrl: this.curSpeakerAudio.audioUrl,
			on: {
				'error': this.decompressErrorCallback,
				'ended': this.audioEndCallback,
				'pause': this.audioEndCallback,
				'audioTimeupdate': this.decompressPlayCallback,
				'changeLoading': this.changeLoading,
				'changeSegment': this.decompressSegmentChangeCallback,
				'durationchange': () => {
					this.audioDuration = this.timeDecompressPlayer.duration
				}
			},
			segments: this.segmentsList, 
			canvasRef: this.shortPlayerStyle,
		})
		this.timeDecompressPlayer.initCallback(() => {
			this.showloading = false
		})
		this.$bus.$on('doClickVideoEditor', () => {
			if(!this.isOncePlay) {
				this.isOncePlay = true;
				if(!this.isPlay && this.currPlayTime === 0) {
					console.log('doClickVideoEditor')
					this.timeDecompressPlayer?.tryPlayFirstVideo();
				}
			}
		});
	}
	decompressPlayCallback(time) {
		this.currPlayTime = time
		this.renderBlurTime = time
		// 设置renderEle
		this.setCurrentRenderEle(time);
		this.getRenderTextEle(time)
	}
	initAudioPlayer() {
		this.timeAudioPlayer = new audioPlayer({
			audioUrl: this.curSpeakerAudio.audioUrl, on: {
				'error': this.audioEndCallback,
				'ended': this.audioEndCallback,
				'pause': this.audioEndCallback,
				'timeupdate': this.audioPlayCallback,
				'durationchange': () => {
					this.audioDuration = this.timeAudioPlayer.duration
				}
			}
		})
	}
	/**
	 * 处理文生图
	 * @param res
	 */
	_handleTextToImage(res) {
		this.promptResult = res.data
		this.taskId = res.data.taskId
		sessionStorage.setItem('taskId', this.taskId)
		let { promptResultVO, composeArticleVO ,taskParam, coverUrl} = res.data
		this.defaultCoverUrl = coverUrl
		if (this.isDownStress) {
			this.reDownStressPlayLineTrack(promptResultVO)
			this.getVideoEndTime(this.textList)
		} else {
			this.reLineTrack(promptResultVO)
			this.getVideoEndTime(promptResultVO.promptImageVOList)
		}
		
		let speakerName = composeArticleVO.extendVO.speakerName
		if (speakerName) {
		  speakerName = speakerName.split('|')[0]
		}
		let speaker = composeArticleVO.extendVO.speaker
		let style = composeArticleVO.extendVO.speakerStyle
		let speed = composeArticleVO.extendVO.speechSpeed
		this.isGreenScreen = composeArticleVO.styleCode === 'green_screen';
		if (taskParam.dub) {
			const dubParam = taskParam.dub
			// 这里获取最新保存的数据与原始数据进行对比，把旧的赋值成新的
			const taskTextList = this.getViewTextList(dubParam.textList)
			const _textList = this.getDubParamTextList(dubParam.textList)
			this.getttsWordVOList(_textList)
			this.updateTTSWordList()
			let flag = this.compareTextList(_textList, dubParam.textList)
			if (taskTextList.length && flag) {
				taskTextList.forEach((text, index) => {
					if (this.textList[index] && text !== this.textList[index].text) {
						this.textList[index].text = text
					}
				})
			}
			if ((speakerName !== dubParam.speakerName && dubParam.speakerName) || style !== dubParam.speakerStyle || speed !== dubParam.speed) {
				if (dubParam.speakerName && dubParam.speaker) {
					speakerName = dubParam.speakerName
					speaker = dubParam.speaker
					style = dubParam.speakerStyle
					speed = dubParam.speed
					flag = true
					console.log('_handleTextToImage-flag1', flag)
				}
			}
			if (dubParam.bgmUrl) {
				// 由于背景音乐被删除，前端手动替换背景音乐域名为腾讯 CDN 地址
				// const bgmUrl = this.replaceBgmUrl(taskParam.bgmUrl)
				this.backAudio = {
					audioUrl:taskParam.bgmUrl,
					audioName:taskParam.bgmName,
					duration:taskParam.bgmDuration,
				}
			}
			if (!flag) {
				this.isCanReAudio = false
			} else {
				this.isCanReAudio = true
			}
		} else {
			this.isCanReAudio = false
		}

		// 模板参数
		if (taskParam.textTemplateList) {
			this.initTextTemplateList(taskParam.textTemplateList)
		}

		if (taskParam.coverUrl) {
			coverUrl = taskParam.coverUrl
		}
		if(!speakerName) speakerName = '';
		const speakerNameList = speakerName.split('|')

		let scaleCode = composeArticleVO.extendVO.scaleCode
		this.scaleRatio = scaleCode
		if (scaleCode) {
			[this.canvasWidth, this.canvasHeight] = WHRATIO[scaleCode].size
		}

		this.curSpeakerAudio.speakerName = speakerNameList[0]
		this.curSpeakerAudio.speaker = speaker
		this.curSpeakerAudio.style = style
		this.curSpeakerAudio.speed = speed
		this.curSpeakerAudio.audioUrl = this.replaceBgmUrl(promptResultVO.audioUrl)

		if(taskParam.bgmUrl && taskParam.dub){
			// 由于背景音乐被删除，前端手动替换背景音乐域名为腾讯 CDN 地址
			// const bgmUrl = this.replaceBgmUrl(taskParam.bgmUrl)
			this.backAudio = {
				audioUrl:taskParam.bgmUrl,
				audioName:taskParam.bgmName,
				duration:taskParam.bgmDuration,
			}
		}
		this.state.articleInfo = {
			articleId: this.articleId,
			uniqueId: composeArticleVO.uniqueId,
			extendVO: composeArticleVO.extendVO,
			title: composeArticleVO.title,
			transformContent: composeArticleVO.extendVO.transformContent
		}
		this.checkBgTcAccesspass()
		// this.initBackAudio()
		if (taskParam.coverMaterialList) {
			this.coverMaterialList = taskParam.coverMaterialList
		}
		if (coverUrl) {
			this.imgCoverUrl = changeUrl2Cdn(coverUrl)
		}
		this.renderEle ={
			imgUrl: this.imgCoverUrl,
			text: this.textList[0].text,
			imageId: this.imgList[0]?.imageId,
		}
		this.setSrtParam(taskParam)
		this._queryMemberLeftRight()
		this.$emit('set-scale-ratio', this.scaleRatio)
		this.saveProject();
		(this.$parent.$refs?.stylePopupRef as any)?.initFontFamily();
	}
	/**
	 * 检查背景音是否可以正常访问
	 * 如果不可以就替换成腾讯域名
	 */
	checkBgTcAccesspass() {
		if (!this.backAudio.audioUrl) {
			this.initBackAudio()
			return
		}
		Axios.head(this.backAudio.audioUrl).then((res) => {
		}).catch(err => {
			this.backAudio.audioUrl = this.replaceBgmUrl(this.backAudio.audioUrl)
		}).finally(() => {
			this.initBackAudio()
		})
	}

	getVideoEndTime(list) {
		if (list.length) {
			let endTime = list[list.length - 1].endTime
			if (this.isDownStress) {
				endTime = endTime * 1000
			}
			this.state.operatingTextTemplateInfo.end_time = endTime
		}
	}

	getShortVideoEndTime(list) {

	}
	/**
	 * 获取会员权益
	 */
	_queryMemberLeftRight() {
		this.$http('queryMemberLeftRight').then((res) => {
			if (res.code === 200) {
				this.vipInfo = res.data
			}
		})
	}
	/**
	 * 设置字幕参数
	 */
	setSrtParam(taskParam:any) {
		if (taskParam.bgmVolume) {
			this.changeBgVolume(Number(taskParam.bgmVolume) * 100)
			this.$emit("update-bgVolume", Number(taskParam.bgmVolume))
		}
		if (!taskParam || !taskParam.srtParam) {
      this.state.subtitleInfo.fontPercent = DEFAULTFONTSIZE[this.scaleRatio] || 8
      return
    }
		const srtParam = taskParam.srtParam
		const alpha =  bgaToColor(srtParam.primaryColour).alpha
		const _srtParam = {
			fontColour: bgaToColor(srtParam.primaryColour).color || '', // 字体颜色
			fontPercent: srtParam.fontPercent || DEFAULTFONTSIZE[this.scaleRatio] || 8, // 新-字体大小
			alpha: alpha !== undefined ? alpha : 1, // 字体透明度
			bgColor: bgaToColor(srtParam.backColour).color, // 背景颜色
			fontStrokeColor: bgaToColor(srtParam.outlineColour).color, // 字体描边颜色
			fontStrokeWidth: 0.01, // 字体描边宽度
			bgMode: srtParam.backColour ? 'consummation' : 'none', // 背景模式
			bgAlpha: 1, // 背景透明度
			type: 1, // 操作类型 1 正常赋值 2 撤销回退重新复制
			scale: srtParam.scaleX || 1,
			marginV: +srtParam.marginRatio || 0.1,
			fontFamily: srtParam.fontname || 'TsangerShuYuanT W02'
		}
		console.log('setSrtParam', taskParam.srtParam)
		this.state.subtitleInfo = {...this.subtitleInfo, ..._srtParam};
		
	}
	get imageObj() {
		let obj = {}
		this.imgList.forEach(item => {
			obj[item.imageId] = item
		})
		return obj
	}
	get undoImg() {
		// /images/video_editor/revertImg.png
		return this.canUndo ? this.$publicPath + 'images/video_editor/revertImg.png' : this.$publicPath + 'images/video_editor/revert_img_gray.png'
	}
	get revertImg() {
		return this.canRedo ? this.$publicPath + 'images/video_editor/nextImg.png' : this.$publicPath + 'images/video_editor/next_img_gray.png'
	}

	subtitlesEditCallback(uuid, showEditor = true) {
		this.uuidSelectedText = uuid; // 选中字幕uuid
		this.startAudioPlay(false);
		if(!showEditor) return; // 不弹出样式编辑弹窗
		let type: any = 'text';
		let textList = this.textList;
		let index = textList.findIndex(item => item.uuid === uuid);
		if(index === -1) {
			const y = uuid.split('_')[0]
			type = 'text' + y;
			textList = this.extraTextMap[y] || [];
			index = textList.findIndex(item => item.uuid === uuid);
		}
		this.curSelect = {
			type: type,
			selectIndex: index
		}
		const {text,srtParam = {}} =  textList[index] ||  {};
		const params =  {
			text,
			uuid: uuid,
			source: 'shortPlay',
			fontColour: srtParam.fontColour, // 字体颜色
			alpha: srtParam.alpha || 1, // 字体透明度
			fontPercent: (srtParam.fontSize / this.fontsizeRatio) || 8, // 新-字体大小
			fontFamily: srtParam.fontFamily || 'Douyin Sans',
		}
		Object.assign(this.state.subtitleInfo, params)
		this.state.subtitleInfo.textList = textList; // 设置textList，用来判断更新哪个轨道数据
		this.$emit('editor-subtitle',params);
		this.isEdit = true;
	}
	subtitlesChangeCallback(config) {
		if(!this.uuidSelectedText) return;
		console.log('subtitlesChangeCallback', config, this.uuidSelectedText)
		const textList = this.state.subtitleInfo.textList;
		textList.forEach(item => {
			const { srtParam = {}, uuid } = item;
			// 更改文本轨道对应配置
			item.srtParam = {
				...srtParam,
				...config,
			};
			// 更改segment对应配置
			this.updateSrtParamByUuid(uuid, config);
		})
		this.timeSegmentPlayer?.updateSubtitle(this.segmentsList);
		this.updateShortPlayPromptInfo();
	}
	updateSrtParamByUuid(uuid, config) {
		if(!uuid) return;
		const [ y, segmentIndex, capIndex ] = uuid.split('_')
		const textList = this.segmentsList[segmentIndex]?.textList || [];
		for (let index = 0; index < textList.length; index++) {
			const item = textList[index];
			if (item.uuid === uuid) {
				item.srtParam = {
					...item.srtParam,
					...config,
				};
				const cap = this.shortCut.segments[segmentIndex].subtitles.captions[capIndex];
				const { fontSize, fontColour, fontFamily, ...srtParam } = item.srtParam;
				cap.srtParam = {
					...srtParam,
					fontsize: fontSize,
					fontname: fontFamily,
					fontColour: colorTobga(item.srtParam.fontColour, 1)
				};
				break;
			}
		}
	}
	// 更新短剧字幕
	updateShortPlayPromptInfo() {
		const param = {
			taskId: this.taskId,
			articleId: this.articleId,
			shortCut: {
				segments: this.shortCut.segments
			}
		}
		this.$http('updateShortPlayPrompt',param)
	}
	// 更新短剧信息
	getShortPlayTaskParam() {
		// 保存的文本列表
		const savedTextList = this.state.savedTextList
		// 素材列表
		let materialList = []
		if (this.state.operatingTextTemplateInfo.url) {
			// 文字模板（按照视频素材传参数）
			materialList.push({
				type: 'video',
				url: this.state.operatingTextTemplateInfo.url,
				wRatio: 1,
				hRatio: 1,
				xRatio: 0,
				yRatio: 0,
				start_time: this.state.operatingTextTemplateInfo.start_time,
				end_time: this.state.operatingTextTemplateInfo.end_time
			})
		}
		const param = {
			taskId: this.taskId,
			articleId: this.articleId,
			fps: this.frameRateValue,
			codeRate: this.codeRateValue,
			// 背景音
			bgmUrl: this.backAudio.audioUrl || '',
			bgmName: this.backAudio.audioName || '',
			bgmDuration: this.backAudio.duration || 0,
			bgmVolume: `${this.bgVolume / 100}` || '1',
			// 封面
			coverUrl: this.imgCoverUrl || null, // 偶现传空字符串删除封面图的问题，目前没有删除封面功能，拿到''先传null
			coverMaterialList: this.coverMaterialList,
			materialList,
			textTemplateList: savedTextList
		}
		return param;
	}
	async updateShortPlay(needCompare = true) {
		const param = this.getShortPlayTaskParam();
		// 比较差异，没有时不更新短剧
		const compareList = needCompare ? compareObjects(this.shortPlayTaskParam, param) : [];
		if(needCompare && !compareList.length) return;
		this.shortPlayTaskParam = param;
		return this.$http('updateShortPlayTask', param);
	}
	// 导出短剧
	async generateShortPlayTaskSubmit() {
        const [err, resCreate]: any = await to(this.updateShortPlay(false));
        if (err || resCreate?.code !== 200) {
            toast(err?.message || resCreate?.message || '导出失败')
            stepApiMonitor({
                monitorId: this.isShortPlay ? "work.shortExport" : "work.novalExport",
                stepId: "createComposeTask",
                errorCode: err?.code || resCreate?.code,
                errorMsg: err?.message || resCreate?.message,
                extraInfo1: this.articleId,
            });
            return;
        }
		const param = {
			taskId: this.taskId,
			articleId: this.articleId,
			fps: this.frameRateValue,
			codeRate: this.codeRateValue,
			deduplication: this.deduplication
		}
		const resSubmit = await this.$http('shortPlayTaskSubmit', param);
		if (resSubmit.code === 40401500) {
			toast('已有导出任务正在进行中，请稍后重试')
		} else if(resSubmit.code === 200) {
			this.taskSubmitSuccess(resSubmit);
		}
	}
	taskSubmitSuccess(res) {
		if(this.isApp){
			let appSaveVideo = (<any>window).appSaveVideo;
			appSaveVideo.postMessage(JSON.stringify(res.data));
		}else{
			this.doClear();
			this.$navigateTo({
				url: `/baohuo-package/pages/export-video/export-video?taskId=${this.taskId}`,
			})
		}
	}
	async generateTaskSubmit() {
        const [err]: any = await to(this.saveVideoPromot())
        if (err) {
            toast('提交导出任务出错')
            stepApiMonitor({
                monitorId: this.isShortPlay ? "work.shortExport" : "work.novalExport",
                stepId: "createComposeTask",
                errorCode: err?.code,
                errorMsg: err?.message,
                extraInfo1: this.articleId,
            });
            return
        }

    let self = this;
		let requestName = this.isDownStress ? 'exportDownStressSubmit' : 'taskSubmit'
		if (this.isCanReAudio) {
			this.reCreateAudio().then((res:any) => {
				let param = this.getCurSaveParam()
				this.$http(requestName, param).then(res => {
					if (res.code === 40401500) {
						toast('已有导出任务正在进行中，请稍后重试')
						return
					}
					this.onTouchStart()
          if(self.isApp){
            let appSaveVideo = (<any>window).appSaveVideo;
            appSaveVideo.postMessage(JSON.stringify(res.data));
          }else{
            this.$navigateTo({
              url: `/baohuo-package/pages/export-video/export-video?taskId=${this.taskId}`,
            })
          }
				})
			})
		}else{
			let param = this.getCurSaveParam()
      let self = this;
			this.$http(requestName, param).then(res => {
				if (res.code === 40401500) {
					toast('已有导出任务正在进行中，请稍后重试')
					return
				}
				this.onTouchStart()
        if(self.isApp){
          let appSaveVideo = (<any>window).appSaveVideo;
          appSaveVideo.postMessage(JSON.stringify(res.data));
        }else{
          this.$navigateTo({
            url: `/baohuo-package/pages/export-video/export-video?taskId=${this.taskId}`,
          })
        }
			})
		}
		
	}
	saveVideoPromot() {
		if(this.isShortPlay) return this.updateShortPlay();  // 短剧更新
		return new Promise((r,j)=>{
			let param = this.getCurSaveParam()
			this.$http('createAndUpdateTask', param).then(res => {
				r(res);
			}).catch((err)=>{
				j(err)
			})
		})
	}
	updateAricleAiStatus() {
		const params = {
			articleId: this.articleId,
			uniqueId: this.state.articleInfo.uniqueId
		}
		this.$http('updateArticleAi', params)
	}
	getCurSaveParam() {
		let subtitleInfo = this.subtitleInfo
		const scaleRatioList = (this.scaleRatio + '').split(':')
		const resolution = this.resolution;
		let playResX = 0
		let playResY = 0
		if (Number(scaleRatioList[0]) < Number(scaleRatioList[1])) {
			playResX = Number(resolution)
			playResY = Number(resolution) / (Number(scaleRatioList[0]) / Number(scaleRatioList[1]))
		} else {
			playResY =  Number(resolution)
			playResX = Number(resolution) * (Number(scaleRatioList[0]) / Number(scaleRatioList[1]))
		}
		playResX = Math.round(playResX);
		playResY = Math.round(playResY);
		const srtParam:any = {			
			fontPercent: subtitleInfo.fontPercent || 8, // 新-字体大小
			primaryColour: colorTobga(subtitleInfo.fontColour, subtitleInfo.alpha),
			outlineColour: colorTobga(subtitleInfo.fontStrokeColor, subtitleInfo.alpha),
			backColour: subtitleInfo.bgMode !== 'none' ? colorTobga(subtitleInfo.bgColor) : null,
			outline: 3,
			spacing: 2,
			borderStyle: subtitleInfo.bgMode !== 'none' ? 3 : 1,
			marginRatio: subtitleInfo.marginV,
			playResX,
			playResY,
			fontname: subtitleInfo.fontFamily || 'TsangerShuYuanT W02'
		}
		const dubParams = {
			taskId: this.taskId,
			articleId: this.articleId,
			speaker: this.curSpeakerAudio.speaker,
			speed: this.curSpeakerAudio.speed,
			speakerStyle: this.curSpeakerAudio.style,
			speakerName: this.curSpeakerAudio.speakerName,
			pitch: 0,
			product: 'baohuo',
			volume: this.bgVolume || 80,
			textList: this.getDubParamTextList()
		}
		// 保存的文本列表
		const savedTextList = this.state.savedTextList
		// 素材列表
		let materialList = []
		if (this.state.operatingTextTemplateInfo.url) {
      // 播放器容器宽高
      // const container = document.getElementById('videoImgCanvas') as HTMLCanvasElement
      // const containerWidth = container.clientWidth
      // const containerHeight = container.clientHeight
			// 文本内容（按照视频素材传参数）
			materialList.push({
				type: 'video',
				url: this.state.operatingTextTemplateInfo.url,
				wRatio: 1,
				hRatio: 1,
				xRatio: 0,
				yRatio: 0,
				start_time: this.state.operatingTextTemplateInfo.start_time,
				end_time: this.state.operatingTextTemplateInfo.end_time
			})
		}
		this.state.oldTextTemplateInfo.materialList = JSON.parse(JSON.stringify(materialList))
		this.state.oldTextTemplateInfo.textTemplateList = JSON.parse(JSON.stringify(savedTextList))
		if (!this.taskId) {
			console.log('getCurSaveParam-taskId不能为空')
			// toast('taskId不能为空')
			return {}
		}
		return {
			taskId: this.taskId,
			articleId: this.articleId,
			coverUrl: this.imgCoverUrl,
			bgmUrl: this.backAudio.audioUrl || '',
			bgmName: this.backAudio.audioName || '',
			bgmDuration: this.backAudio.duration || 0,
			fps: this.frameRateValue,
			// resolution: this.resolutionRatio,
			codeRate: this.codeRateValue,
			bgmVolume: this.bgVolume / 100 || 0.1,
			srtParam: srtParam,
			coverMaterialList: this.coverMaterialList,
			dub: dubParams,
			textTemplateList: savedTextList,
			materialList
		}
	}
	/**
	 * 获取tts word
	 */
	getCurTTsWordVOList(info) {
		const { diffList, pinyinWordList, orginialNumberTextList, checkedInfo, currentText } = info
		const imageId = this.textList[this.renderEleIndex].imageId
		let ttsWordVOList = []
		this.isCanReAudio = true
		const numberList = []
		const currentList = this.ttsWordVOList.filter(item => item.sentenceIndex === this.renderEleIndex)
		if (checkedInfo.isNumChecked) {
			let numberIndex = 0
			orginialNumberTextList.forEach(item => {
				Array.from(item.text).forEach((word, i) => {
					numberIndex = numberIndex + 1
					const ttsWordVOInfo:any = {
						sentenceIndex: this.renderEleIndex,
						word: word,
						imageId,
						index: numberIndex,
					}
					if (item.type === 'num' && item.curArticulation) {
						ttsWordVOInfo.tnChange = true
						ttsWordVOInfo.numberRead = item.curArticulation
					}
					numberList.push(ttsWordVOInfo)
				})
			})
		}
		console.log('getCurTTsWordVOList-diffList-before', JSON.parse(JSON.stringify(diffList)))
		console.log('getCurTTsWordVOList-currentList-before', JSON.parse(JSON.stringify(currentList)))
		this.resetWIndex(diffList, currentList)
		this.resetPinOrNum(diffList, pinyinWordList, numberList, currentText)
		console.log('getCurTTsWordVOList-diffList', JSON.parse(JSON.stringify(diffList)))
		console.log('getCurTTsWordVOList-currentList', JSON.parse(JSON.stringify(currentList)))
		let wIndex = 0
		let isNext = false
		diffList.forEach((item, index) => {
			let value = item.value
			const valueList = Array.from(value)
			for(let i=0; i < valueList.length; i++) {
				const word = valueList[i]
				wIndex = wIndex + 1
				const pinyinInfo = pinyinWordList.find(item => item.wIndex === wIndex && item.curpinyin)
				const numberInfo = numberList.find(item => item.wIndex === wIndex && item.numberRead)
				let _sentenceIndex = this.renderEleIndex
				if (word === '\n') {
					isNext = true
					continue
				}
				if (isNext) {
					_sentenceIndex = this.renderEleIndex + 1
				}

				let ttsWordVOInfo:any = {
					sentenceIndex: _sentenceIndex,
					index:this.renderEleIndex,
					word: word,
					imageId,
					wIndex,
          isEditChecked: checkedInfo.isEditChecked
				}
				if (numberInfo) {
					ttsWordVOInfo = {...numberInfo, ...ttsWordVOInfo}
				}
				if (pinyinInfo && checkedInfo.isWordChecked) {
					ttsWordVOInfo.pinyin = pinyinInfo.curpinyin
				
				}
				if (item.replaced) {
					if (!checkedInfo.isForce) {
						ttsWordVOInfo.aliasChange = checkedInfo.isEditChecked,
						ttsWordVOInfo.aliasContent = item.oldVal
						ttsWordVOInfo.aliasLen = item.value.length
					}
					
					ttsWordVOInfo.word = word
					ttsWordVOInfo.highlight = item.highlight
          if (item.removeVal) {
            ttsWordVOInfo.removeVal = item.removeVal
          }
				}
				ttsWordVOList.push(ttsWordVOInfo)
			}
			
		})
		if (!checkedInfo.isForce) {
			ttsWordVOList.forEach((item, index) => {
				const info = currentList.find(w => w.wIndex === item.wIndex && w.word === item.word)
        if (info) {
          if (info.pinyin && !item.pinyin) {
            item.pinyin = info.pinyin
          }
          if (info.numberRead && !item.numberRead) {
            item.numberRead = info.numberRead
            item.tnChange = info.tnChange
          }
          if (!item.highlight && (info.highlight === 'replaced' || info.highlight === 'remove') && info.aliasChange && !checkedInfo.isEditChecked) {
						
            item.aliasChange = info.aliasChange
            item.aliasContent = info.aliasContent
            item.aliasLen = info.aliasLen
						item.highlight = info.highlight
						item.removeVal = info.removeVal
          }
        } 
        if (item.highlight === 'add') {
          if (!checkedInfo.isEditChecked) {
            if (!item.aliasContent) {
  						item.aliasChange = true
              item.aliasLen = 1
            }
          } else {
            this.delAlias(item)
          }
        } else if (item.highlight === 'remove') {
          if (!checkedInfo.isEditChecked) {
            if (this.checkLastIndex(ttsWordVOList, index, 'remove')) {
							const removeInfo = currentList[item.wIndex]
							if (item.aliasContent && item.removeVal && removeInfo && removeInfo.aliasChange && removeInfo.highlight === 'add' && removeInfo.aliasContent === '') {
								this.delAlias(item)
							} else if (item.aliasContent && item.removeVal) {
								item.aliasChange = true
							} else {
								this.delAlias(item)
							}
              
            } else {
              const removeInfo = currentList[item.wIndex]

              if (removeInfo && removeInfo.removeVal && removeInfo.highlight !== 'replaced') {
                item.aliasContent = item.aliasContent + removeInfo.removeVal
								item.aliasChange = true
              } else if (removeInfo && removeInfo.aliasChange && removeInfo.highlight === 'replaced') {
                item.aliasContent = removeInfo.aliasContent
								item.aliasChange = true
              }  else if (info && info.aliasChange && info.highlight === 'remove' && !item.aliasContent) {
								item.aliasContent = info.aliasContent
								item.aliasChange = true
							} 
							// else if (info && (!info.highlight && !info.aliasChange)) {
							// 	this.delAlias(item)
							// } 
							else {
								item.aliasChange = true
							}
             
            }
            
          } else {
						this.delAlias(item)
          }
        } else if (item.highlight === 'replaced') {
          if (!checkedInfo.isEditChecked) {
						if (item.type === 'del') {
							this.delAlias(item)
						} else {
							const rpInfo = currentList.find(_item => _item.wIndex === item.wIndex)
							if (info && info.highlight === 'replaced' && info.aliasChange) {
								const nextInfo = currentList.find(nextInfo => nextInfo.wIndex === info.wIndex + 1)
								if (item.pinyin) {
									this.delAlias(item)
									if (nextInfo && nextInfo.highlight === 'replaced' && nextInfo.aliasChange) {
										if (ttsWordVOList[index + 1]) {
											ttsWordVOList[index + 1].type = 'del'
										}
									}
								} else {
									item.aliasContent = rpInfo.aliasContent
								}
							}else if (rpInfo && rpInfo.highlight === 'replaced' && rpInfo.aliasChange) {
								item.aliasContent = rpInfo.aliasContent
							}
							item.aliasChange = true
						}
            
          } else {
            this.delAlias(item)
          }
        } else if (item.pinyin) {
          if (info && info.highlight === 'replaced' && info.aliasChange) {
            this.delAlias(item)
          }
        } else if (!item.highlight && item.aliasChange) {
          this.delAlias(item)
        }

			})
		}
		
		const list = this.ttsWordVOList.filter(item => item.sentenceIndex !== this.renderEleIndex)
		// ttsWordVOList = [...list, ...ttsWordVOList]
		let uniqueArray = this.removeDuplicates(ttsWordVOList)
		this.ttsWordVOList = JSON.parse(JSON.stringify(uniqueArray))
		this.saveVideoPromot()
		// this.saveProject()
	}
	removeDuplicates(arr) {
		const seen = new Set();
		return arr.filter(item => {
				const str = JSON.stringify(item);
				if (!seen.has(str)) {
						seen.add(str);
						return true;
				}
				return false;
		});
	}

  checkLastIndex(arr, index, tag) {
    let flag = true
    for (let i=index; i < arr.length; i++) {
      if (arr[i].highlight !== tag) {
        flag = false
        break
      }
    }
    return flag
  }
	/**
	 * 删除别名
	 * @param info
	 */
	delAlias(info) {
		delete info.aliasContent
		delete info.aliasLen
		delete info.aliasChange
	}
  /**
   * 重置索引
   */
  resetWIndex(diffList, arr) {
    let wIndex = 0
    let list = []
		arr.forEach((item, index) => {
		  item.wIndex = index + 1
		})
		const _diffList = JSON.parse(JSON.stringify(diffList))
    _diffList.forEach(item => {
      Array.from(item.value).forEach(word => {
        wIndex = wIndex + 1
        let info = {
          word,
          wIndex
        }
        if (item.highlight !== 'add' && item.highlight !== 'replaced') {
          list.push(info)
        }
        if (item.highlight === 'replaced' && !item.isUse) {
          Array.from(item.oldVal).forEach(val => {
            list.push({
              word: val,
              type: 'replaced',
              wIndex
            })
          })
          item.isUse = true
        }
        else if (item.highlight === 'remove' && item.removeVal) {
          Array.from(item.removeVal).forEach(val => {
            list.push({
              word: val,
              type: 'remove',
              wIndex
            })
          })
        }
      })
    })
    arr.forEach((item, index) => {
      if (list[index]) {
        item.wIndex = list[index].wIndex
      }
    })
		
  }
	resetPinOrNum(diffList, pinyinList, numbList, currentText) {
		let wIndex = 0
    let pyinList = []
		let numList = []
		const diffText = currentText
		let pinyinText = ''
		let numText = ''
		if (pinyinList.length) {
			pinyinList = this.pinyinExtractNum(pinyinList)
			pinyinText = this.getPinOrNumText(pinyinList)
		}
		if (numbList.length) {
			numText = this.getPinOrNumText(numbList)
		}
		let isPyin = pinyinText && (diffText !== pinyinText)
		let isNum = numText && (diffText !== numText)
		if (isPyin || isNum) {
			const _diffList = JSON.parse(JSON.stringify(diffList))
			_diffList.forEach(item => {
				Array.from(item.value).forEach(word => {
					wIndex = wIndex + 1
					let info = {
						word,
						wIndex
					}
					if (item.highlight !== 'add' && item.highlight !== 'replaced') {
						if (isPyin) {
							pyinList.push(info)
						}
						if (isNum) {
							numList.push(info)
						}
					}
					
					if (item.highlight === 'remove' && item.removeVal) {
						Array.from(item.removeVal).forEach(val => {
							if (isPyin) {
								pyinList.push({
									word: val,
									type: 'remove',
									wIndex
								})
							}
							if (isNum) {
								numList.push({
									word: val,
									type: 'remove',
									wIndex
								})
							}
							
						})
					} else if (item.highlight === 'replaced' && item.replaced === true && !item.isUse) {
						Array.from(item.oldVal).forEach(val => {
							if (isPyin) {
								pyinList.push({
									word: val,
									type: 'remove',
									wIndex
								})
							}
							if (isNum) {
								numList.push({
									word: val,
									type: 'remove',
									wIndex
								})
							}
						})
						item.isUse = true
					}
				})
			})
			if (isPyin) {
				pinyinList.forEach((item, index) => {
					if (pyinList[index]) {
						item.wIndex = pyinList[index].wIndex
					}
				})
			} else {
				this.addWIndex(pinyinList)
			}
			if (isNum) {
				numbList.forEach((item, index) => {
					if (numList[index]) {
						item.wIndex = numList[index].wIndex
					}
				})
			} else {
				this.addWIndex(numbList)
			}
		} else {
			this.addWIndex(pinyinList)
			this.addWIndex(numbList)
		}
	}
	addWIndex(arr) {
		arr.forEach((item,index) => {
			item.wIndex = index + 1
		})
	}
	/**
	 * 拼音抽取数字
	 * @param pinyinList
	 */
	pinyinExtractNum(pinyinList) {
		let newList = []
		pinyinList.forEach((item, index) => {
		  if (/^[\d.]+$/.test(item.word)) {
				Array.from(item.word).forEach((word) => {
					const info = {
						...item,
						word
					}
					newList.push(info)
				})
			} else {
				newList.push(item)
			}
		})
		return newList
	}
	getPinOrNumText(arr) {
	  let text = ''
		arr.forEach(item => {
			text += item.word
		})
		return text
	}
	/**
	 * 获取当前文本
	 * @returns
	 */
	getCurSubtitle() {
		return this.textList[this.renderEleIndex].text
	}
	changeBgVolume(val) {
		this.backAudioPlayer.changeVolume(val / 100)
		this.bgVolume = val
	}
	/**
	 * 删除背景音
	 */
	deleteBgm() {
		
		this.backAudio = {
			audioUrl: '',
			audioName: '',
			duration: 158,
		}
		this.backAudioPlayer.updateAudioUrl(this.backAudio)
		this.saveProject()
		this.saveVideoPromot()
	}
	getDirectionByPath(path) {
		if(!path) return '';
		let direction = '';
		const endXRatio = +path.endXRatio;
		const endYRatio = +path.endYRatio;
		if(endYRatio === 0) {
			// 偏移y轴比例为0，说明左右移动；目前左右移动比例为20%，故纵向也放大20%显示
			if(endXRatio < 0) {
				direction = 'left';
			} else {
				direction = 'right';
			}
		} else if(endXRatio === 0) {
			// 偏移x轴比例为0，说明上下移动；目前上下移动比例为20%，故横向也放大20%显示
			if(endYRatio < 0) {
				direction = 'up';
			} else {
				// 屏幕坐标系中，y轴正方向是向下
				direction = 'down';
			}
		}
		return direction;
	}
	saveJoggingMove() {
		// if(this.imgList[0].path){
		// 	return
		// }
		// 转场方向transitionType；微动数据path
		let paramList = this.imgList.map((item, index) => {
			if (item.direction) {
				if (item.direction == 'left') {
					// 左右移动时，startYRatio为-0.1因为上下都被截取10%；
					// 左移，x方向移动图片，坐标0 -> -0.2
					return {
						"imageId": item.imageId,    //图片id
						"path": {
							"startXRatio": "0", //开始x轴比例
							"startYRatio": "-0.1", //开始y轴比例
							"endXRatio": "-0.2", //偏移x轴比例
							"endYRatio": "0", //偏移y轴比例
							"duration": (item.endTime-item.startTime), //持续时间
						},
						transitionDuration:TRANSTIME,
						transitionType:item.slideType
					}
				} else if (item.direction == 'right') {
					// 右移，x方向移动图片，坐标-0.2 -> 0
					return {
						"imageId": item.imageId,    //图片id
						"path": {
							"startXRatio": "-0.2", //开始x轴比例
							"startYRatio": "-0.1", //开始y轴比例
							"endXRatio": "0.2", //偏移x轴比例
							"endYRatio": "0", //偏移y轴比例
							"duration": (item.endTime-item.startTime) , //持续时间
							
						},
						transitionDuration:TRANSTIME,
						transitionType:item.slideType
					}
				} else if (item.direction == 'up') {
					// 上下移动时，startXRatio为-0.1因为左右都被截取10%。
					return {
						"imageId": item.imageId,    //图片id
						"path": {
							"startXRatio": "-0.1", //开始x轴比例
							"startYRatio": "0", //开始y轴比例
							"endXRatio": "0", //偏移x轴比例
							"endYRatio": "-0.2", //偏移y轴比例
							"duration": (item.endTime-item.startTime) , //持续时间
						},
						transitionDuration:TRANSTIME,
						transitionType:item.slideType
					}
				} else if (item.direction == 'down') {
					return {
						"imageId": item.imageId,    //图片id
						"path": {
							"startXRatio": "-0.1", //开始x轴比例
							"startYRatio": "-0.2", //开始y轴比例
							"endXRatio": "0", //偏移x轴比例
							"endYRatio": "0.2", //偏移y轴比例
							"duration": (item.endTime-item.startTime)  , //持续时间
						},
						transitionDuration:TRANSTIME,
						transitionType:item.slideType
					}
				}
			}
		})
		this.$http('updateImageMovePrompt', {
			articleId: this.articleId,
			taskId: this.taskId,
			promptImageVOList: paramList
		}).then(res => {
			console.log('saveJoggingMove',res);
		})
	}
	beforeDestroy() {
		this.doClear();
	}
	doClear() {
		if (this.isPlay) {
			this.tryAudioPlay(false)
		}
		this.projectHistory.removeAllProjectDataFromStorage()
		this.audioEndCallback()
		this.timeAudioPlayer?.destroy()
		this.timeSegmentPlayer?.destroy();
	}
	// 项目数据
	get saveProjectData() {
		if(this.isShortPlay) {
			return {
				backAudio: this.backAudio || {},
				bgVolume: this.bgVolume,
				imgCoverUrl: this.imgCoverUrl,
				coverMaterialList: this.coverMaterialList,
				// segmentsList : this.segmentsList,
				// shortCut: this.shortCut,
			}
		}
		return {
			textList: this.textList,
			imgList: this.imgList,
			subtitleInfo: this.subtitleInfo,
			renderEle: this.renderEle,
			curSpeakerAudio: this.curSpeakerAudio,
			backAudio: this.backAudio || {},
			bgVolume: this.bgVolume,
			imgCoverUrl: this.imgCoverUrl,
			exchangeData: this.exchangeData,
			ttsWordVOList: this.ttsWordVOList
		}
	}
	get subtitleInfo() {
		return this.state.subtitleInfo
	}
	/**
	 * 保存文章内容
	 */
	saveProject() {
		// if (this.isShortPlay) return; // 短剧保存暂时不做
		this.projectHistory && this.projectHistory.saveBaseProjectDataToStorage(this.saveProjectData)
	}
	textPlayerCallback(item) {
		this.renderEle.text = item.text
	}
	showExportVideo() {
		this.isShowExportPopup = true
	}
	completeCover(url, coverParams) {
		this.showCover = false
		this.imgCoverUrl = url
		if (coverParams) {
			this.coverMaterialList = coverParams
		} else [
			this.coverMaterialList = []
		]
		this.saveVideoPromot()
		this.startAudioPlay(false)
		this.saveProject()
	}
	closeExportPopup() {
		this.isShowExportPopup = false
	}
	setTransitionEffects() {
	}
	resolutionRatio = '720p'
	resolution = 720
	frameRateValue = 50
	codeRateValue = '推荐'
	deduplication = null
	async exportVideo({ resolutionRatio, resolution, frameRateValue, codeRateValue, deduplication }) {
		this.resolutionRatio = resolutionRatio
		this.resolution = resolution
		this.frameRateValue = frameRateValue
		this.codeRateValue = codeRateValue
		if (deduplication) {
			this.deduplication = deduplication
		}
		// 保存文字模板
		if (this.state.savedTextList.length) {
			// DOM 转为 url
			const [error, url] = await to(domToUrl())
			// 错误直接终止
			if (error) {
				stepApiMonitor({
					monitorId: this.isShortPlay ? "work.shortExport" : "work.novalExport",
					stepId: "uploadImageToOss",
					errorCode: null,
					errorMsg: '',
					extraInfo1: this.articleId,
				});
				return
			}
			this.state.operatingTextTemplateInfo.url = url as string
		}
		// 没有文字模板
		if(this.isShortPlay) {
			this.generateShortPlayTaskSubmit()
			return
		}
		this.generateTaskSubmit()
	}

	screenPlay(type: boolean) {
		if(this.isShortPlay || this.isDownStress){
			// 短剧全屏
			this.isScreen = type;
			this.$emit('changeBottomStatus', !type)
			this.$nextTick(() => {
				this.setShortPlayStyle();
				const playerName = this.isDownStress ? this.timeDecompressPlayer : this.timeSegmentPlayer;
				playerName.resize(this.shortPlayerStyle);
				if(!type) {
					this.setTrackScrollOffsetByTime(); // 滚动时间轴
				}
			})
			return;
		}
		if (type) {
			this.isScreen = true
			this.$emit('changeBottomStatus', false)
			this.$nextTick(() => {
				this.imgPlayer = new ImagePlayer(this.imgList, this.errCallback)
				this.vfx = new VFX(this.$refs.videoCanvasRef, this.specialEffectList)
			})
		} else {
			this.isScreen = false
			this.$emit('changeBottomStatus', true)
			this.$nextTick(() => {
				this.imgPlayer = new ImagePlayer(this.imgList, this.errCallback)
				this.vfx = new VFX(this.$refs.videoCanvasRef, this.specialEffectList)
				this.renderImg()
				// this.initPlayer()
				this.initListener()
				this.setTrackScrollOffsetByTime()
			})
			
		}

	}
	// 全屏播放手动调整时间
	updateCurrPlayTime(time: number, isMounted) {
		this.manualSeekTime(time * 1000_000)
		if(!this.isShortPlay || !isMounted) return;
		// 短剧全屏时，手动调整时间需进行播放或显示
		if(this.isPlay) {
			this.timeSegmentPlayer.play(this.currPlayTime);
			this.updateUIByRaf()
		} else{
			this.timeSegmentPlayer.show(this.currPlayTime);
		}
	}
	// 手动滚动时间轴调整时间
	seekTimeByScrollTrack() {
		this.manualSeekTime(this.getTimeByTrackScrollOffset())
	}
	// 手动调整时间
	manualSeekTime(time) {
		time = time / 1000_000
		if (time <= 0) time = 0
		if(this.isShortPlay) {
			if(time > this.shortDuration)  time = this.shortDuration;
			this.currPlayTime = time;
			this.renderBlurTime = time;
			return;
		}
		if (typeof this.audioDuration === 'number' && time >= this.audioDuration) time = this.audioDuration
		this.currPlayTime = time
	}
	// 每秒应该滚动的长度
	getWidthEverySecond() {
		const trackdom = document.querySelector('.Time-track') as any;
		if (trackdom) {
			const rect = trackdom.getBoundingClientRect()
			return rect.width / 2;
		}
		const baseFontSize = parseFloat(document.documentElement.style.fontSize)
		return baseFontSize * 1.88 / 2
	}
	audioPlayCallback() {
		if (!this.isPlay) {
			return
		}
		const time = this.timeAudioPlayer.currentTime
		this.imgPlayer.drawImageByPlay(time)
		if (!this.isIOS && !this.isScreen) {
			this.vfx.drawVFXByPlay(time)
		}

		this.currPlayTime = time
		// 设置renderEle
		this.setCurrentRenderEle(time);
		this.getRenderTextEle(time)
	}
	setCurrentRenderEle(time) {
		const { text, imageId, imgUrl } = this.getRenderEle(time);
		if(text && this.renderEle.text !== text){
			this.renderEle.text = text;
		}
		if(imageId && this.renderEle.imageId !== imageId) {
			this.renderEle.imageId = imageId;
			this.renderEle.imgUrl = imgUrl;
		}
  }

	audioEndCallback() {
		this.isPlay = false
		this.startAudioPlay(false)
		this.stopUpdateUIByRaf()
	}
	decompressErrorCallback(err) {
		this.audioEndCallback()
	}
	
	errCallback(err) {
		console.log(err);
		this.imgLoading = false
		this.startAudioPlay(false)
		toast('播放失败，请稍后再试')
	}
	reCreateAudio(type?: string) {
		if(this.isShortPlay) return; // 短剧不自动保存
		return new Promise((resolve, reject) => {
      const currSpeaker = this.$store.state.currSpeaker
			let param: any = {
				taskId: this.taskId,
				articleId: this.articleId,
				speaker: this.curSpeakerAudio.speaker,
				speed: this.curSpeakerAudio.speed,
				speakerStyle: this.curSpeakerAudio.style,
				pitch: 0,
				product: 'baohuo',
				volume: 80
			}
      if (currSpeaker) {
        param.voiceType = currSpeaker.voiceType || 0
      }
			let paramTextList = this.getDubParamTextList()
			if(paramTextList.length > 0){
				param.textList = paramTextList
			}
			this.imgLoading = true
			
			this.$http("oneClickComposeAudio", param).then((res) => {
				if (res.code === 200) {
					if (this.isDownStress) {
						this.reDownStressPlayLineTrack(res.data);
					} else {
						this.reLineTrack(res.data);
					}
					this.imgLoading = false
					resolve(res.data);
				} else {
					this.imgLoading = false
					reject(res)
				}
			}).catch((error) => {
				reject(error);
				this.imgLoading = false
			})
		});
	}
	/**
	 * 配音需要的数据结构
	 * @param list
	 * @returns 
	 */
	getDubParamTextList(dubParamText?) {
		let paramTextList = []
		let preIndex = -1
		let commonIndex = -1
		this.textList.forEach((item, idx) => {
			const index = paramTextList.findIndex(_item => _item.imageId === item.imageId)
			let ttsWordVOList = []
			if (dubParamText) {
				const info = dubParamText.find(_item => _item.imageId === item.imageId)
				if (info.ttsWordVOList) {
					ttsWordVOList = JSON.parse(JSON.stringify(info.ttsWordVOList))
				}
				
			}
			if (commonIndex < idx) {
				commonIndex = idx
			} else {
				commonIndex = commonIndex + 1
			}

			if (index === -1) {
				if (item.index === preIndex) {
					// const lastParamTextInfo = paramTextList[paramTextList.length - 1]
					// const _originalIndexList = lastParamTextInfo.originalIndexList
					// const lastInfo = _originalIndexList[_originalIndexList.length - 1]
					// lastInfo.push(idx)
				} else {
					const list = item.text.split('\n')
					const _list = list.filter(text => text.trim() !== '')
					const _textList = []
					const _sentenceIndexList = []
					_list.forEach((text, i) => {
						_textList.push(text)
						commonIndex = commonIndex + i
						_sentenceIndexList.push(commonIndex)
					})
					paramTextList.push({
						imageId: item.imageId,
						textList: _textList,
						sentenceIndexList: _sentenceIndexList,
						ttsWordVOList,
						// originalIndexList: [[idx]]
					})
				}
				
			} else {
				const list = item.text.split('\n')
				const _list = list.filter(_item => _item.trim() !== '')
				_list.forEach((text, i) => {
					commonIndex = commonIndex + i
					paramTextList[index].textList.push(text)
					paramTextList[index].sentenceIndexList.push(commonIndex)
				})
			
			
				if (item.index === preIndex) {
					// const _originalIndexList = paramTextList[index].originalIndexList
					// const lastInfo = _originalIndexList[_originalIndexList.length - 1]
					// lastInfo.push(idx)
				} else {
					// paramTextList[index].originalIndexList.push([idx])
				}
				
			}
			if (this.ttsWordVOList.length) {
				const _ttsWordVOList = JSON.parse(JSON.stringify(this.ttsWordVOList))
				paramTextList.forEach(item => {
					const ttsList = _ttsWordVOList.filter(ttsWordInfo => ttsWordInfo.imageId === item.imageId)
					if (ttsList) {
						let list = []
						item.sentenceIndexList.forEach((sentenceIndex, index) => {
							const _list = _ttsWordVOList.filter(ttsWordInfo => {
								if (ttsWordInfo.sentenceIndex === sentenceIndex) {
									ttsWordInfo.sentenceIndex = index
									return ttsWordInfo
								}
							})
							list = [...list, ..._list]
						})
						if (list.length) {
							item.ttsWordVOList = list
						}
					}
				})
	
			}
			if (item.isEnd) {
				preIndex = -1
			} else {
				preIndex = item.index
			}
			
		})
		return paramTextList
	}
	/**
	 * 处理回显数据
	 * @param _textList 
	 */
	getttsWordVOList(_textList) {
		_textList.forEach((item) => {
			if (item.ttsWordVOList && item.ttsWordVOList.length) {
				item.ttsWordVOList.forEach((_item, idx) => {
					this.ttsWordVOList.push({
						..._item,
						sentenceIndex: item.sentenceIndexList[_item.sentenceIndex]
					})
				}) 
				
			}
		})
	}
	/**
	 * 比较两个参数是否不一样
	 * @param paramTextList 
	 * @param dubTextList 
	 * @returns 
	 */
	compareTextList(paramTextList, dubTextList) {
		if (paramTextList.length !== dubTextList.length) return true
		let flag = false
		for(let i=0; i < dubTextList.length ;i++) {
			const info = paramTextList.find(_item => _item.imageId === dubTextList[i].imageId)
			if (!info || JSON.stringify(dubTextList[i].textList) !== JSON.stringify(info.textList)) {
				flag = true
				break;
			}
		}
		return flag
	} 
	/**
	 * 将配音textList参数，重新组装
	 */
	getViewTextList(list = []) {
		const textList = []
		list.forEach(item => {
			item.textList.forEach(text => {
			  textList.push(text)
			})
		})
		return textList
	}
	/**
	 * 处理轨道数据
	 * @param promptResultVO
	 */
	reShortPlayLineTrack(promptResultVO) {
		const shortCut = promptResultVO.shortCut
		this.shortCut = JSON.parse(JSON.stringify(shortCut));
		// canvas宽高设置
		if (shortCut.width) {
			let scaleCode: any = 0;
			Object.keys(WHRATIO).forEach(key => {
				const [width, height] = key.split(':');
				if (+width / +height === shortCut.width / shortCut.height) {
					scaleCode = key;
				}
			})
			if (scaleCode) {
				this.scaleRatio = scaleCode;
				[this.canvasWidth, this.canvasHeight] = WHRATIO[scaleCode].size
			}
			this.fontsizeRatio = shortCut.height / 200;
		}
		const segmentsList = shortCut.segments
		let textList = []
		const extraTextMapList = [];
		const blurList = [];
		const imgList = [];
		segmentsList.forEach((segment, i) => {
			const { video, audio, subtitles, type } = segment;
			// 音视频地址
			segment.videoUrl = video.video_segment_oss_path;
			segment.audioUrl = audio?.audio_url;
			// 以下3个值单位为秒
			segment.startTime = segment.startTime / 1000;
			// segment.duration = parseInt((audio?.audio_duration || video?.duration || 
			// 	video.end_time - video.start_time) * 1000 + '') / 1000;
			segment.endTime = segment.endTime / 1000;
			// 设置宽度、高度
			segment.width = shortCut.width;
			segment.height = shortCut.height;
			// 倍速
			if(video?.speed && video.speed !== 1) {
				segment.speed = video.speed;
				console.log('segment.speed',video.speed)
			}
			
			// 图片轨道数据处理
			segment.imgList = [];
			if (type === 'image_video') {
				const imgItem = {
					startTime: segment.startTime, // 秒
					endTime: segment.endTime,
					imgUrl: video.image_url,
					thumbnailUrl: video.image_url,
				}
				imgList.push(imgItem);
				segment.imgList.push(imgItem);
			} else {
				const imgs = video.frame_oss_path || [];
				const speed = video.speed || 1; // 倍速
				if(imgs.length) {
					let durationEachImg = 1; // 算法改为1s取一帧
					const durAllImg = (segment.endTime - segment.startTime) * speed;
					if(imgs.length * durationEachImg < durAllImg) {
						durationEachImg = Math.round(Math.ceil(durAllImg) / imgs.length); // 原来算法约2s取一帧
					}
					durationEachImg = durationEachImg / speed; // 除以倍速
					imgs.forEach((img, index) => {
						const imgItem = {
							startTime: segment.startTime + durationEachImg * index,
							endTime: segment.startTime + durationEachImg * (index + 1),
							imgUrl: img,
							thumbnailUrl: img,
						}
						if(index === imgs.length -1) {
							imgItem.endTime = segment.endTime;
						}
						imgList.push(imgItem);
						segment.imgList.push(imgItem);
					})
				}
			}

			// 字幕轨道数据处理
			segment.textList = [];
			if (subtitles && subtitles.captions) {
				subtitles.captions.forEach((caption, capIndex) => {
					const srtParam = caption.srtParam || {};
					// 字幕样式
					const styleObj = {
						fontColour:  bgaToColor(srtParam.fontColour || caption.font_color).color,
						fontPosX: srtParam.fontPosX || caption.font_pos_x,
						fontPosY: srtParam.fontPosY || caption.font_pos_y,
						fontSize: srtParam.fontsize || caption.font_size,
						fontFamily: srtParam.fontname || 'Douyin Sans', // 默认宋体
					};
					caption.texts.forEach((text, index) => {
						const uuid = `${styleObj.fontPosY}_${i}_${capIndex}_${index}`;
						let textObj = {
							uuid,
							srtParam: styleObj,
							text,
							startTime: (segment.startTime * 1000 + caption.timestamp[index][0]) / 1000, // 单位为秒
							endTime: (segment.startTime * 1000 + caption.timestamp[index][1]) / 1000, // 单位为秒
						}
						segment.textList.push(textObj); // 设置textList，后续进行处理
					})
				})
				// 高斯模糊
				const blurs = subtitles.blur || [];
				blurs.forEach((blur) => {
					const { blur_x, blur_y, blur_height, blur_width, timestamp } = blur;
					blur_width.forEach((w, index) => {
						const blurObj = {
							bounding: `${blur_x}_${blur_y}_${w}_${blur_height}`,
							left: 100 * blur_x / segment.width + '%',
							top: 100 * blur_y / segment.height + '%',
							width: 100 * w  / segment.width + '%',
							height: 100 * blur_height / segment.height + '%',
							startTime: (segment.startTime * 1000 + timestamp[index][0]) / 1000, // 单位为秒
							endTime: (segment.startTime * 1000 + timestamp[index][1]) / 1000, // 单位为秒
						}
						blurList.push(blurObj);
					})
				})
			}
			const textMap = this.generateSegmentTextList(segment);
			textList.push(...textMap.textList);
			extraTextMapList.push(textMap.extraMap);
		})
		this.updateTextList(textList, 0)
		if(imgList.length) imgList[0].startTime = 0.01; // 避免首帧图片点击后显示封面
		this.imgList = imgList;
		this.segmentsList = segmentsList;
		this.$nextTick(() => {
			this.initShortPlay();
		})
		this.shortDuration = segmentsList[segmentsList.length - 1].endTime;
		this.curSpeakerAudio.endTime = this.shortDuration; // 总时长，单位秒
		console.log('reShortPlayLineTrack-segmentsList', segmentsList)
		// 其他轨道字幕数据处理
		const extraTextMap = extraTextMapList.reduce((result, item) => {
			Object.keys(item).forEach(key => {
				if(result[key]) {
					result[key] = result[key].concat(item[key]);
				} else {
					result[key] = item[key];
				}
			})
			return result;
		}, {})
		// 遍历extraTextMap，进行缺失的segment段补全
		Object.keys(extraTextMap).forEach(key => {
			const textMap = extraTextMap[key];
			extraTextMap[key] = this.fillTextTrackGap(textMap, 0, this.shortDuration);
		})
		this.extraTextMap = extraTextMap;
		console.log('reShortPlayLineTrack-textList', textList, extraTextMap)

		// 高斯模糊合并
		this.blurList = blurList.reduce((result, obj) => {
			const target = result.find(function (item) {
				return item.bounding === obj.bounding && item.endTime === obj.startTime;
			});
			if (target) {
				Object.assign(target, {	 endTime: obj.endTime });
			} else {
				result.push(obj);
			}
			return result;
		}, [])
		console.log('blurList', this.blurList)
	}

	// 处理Segment字幕，用于字幕轨道显示
	generateSegmentTextList({ textList = [], type, startTime, endTime }) {
		let newTextList = JSON.parse(JSON.stringify(textList));
		if (type !== 'original') {
			// 非原生段字幕进行时间合并，不需要管字幕位置不同，当成同一个段
			newTextList = newTextList.reduce(function (result, obj) {
				const target = result.find(function (item) {
					return item.startTime === obj.startTime && item.endTime === obj.endTime;
				});
				if (target) {
					Object.assign(target, {	text: target.text + ' ' + obj.text});
				} else {
					result.push(obj);
				}
				return result;
			}, []);
			return {
				// 补全，解说段存在audio时长小于video/speed，多出来的部分无字幕
				textList: this.fillTextTrackGap(newTextList, startTime, endTime),
				extraMap: {}
			}
		}

		// 原生段字幕处理为多轨道数据
		// 按y分组
		const textMap = newTextList.reduce((result, currentItem) => {
			const groupKey = currentItem.srtParam?.fontPosY;
			if (!result[groupKey]) {
				result[groupKey] = [];
			}
			result[groupKey].push(currentItem);
			return result;
		}, {})
		// 获取y排序，除了第一组，剩余放extraMap
		const keys = Object.keys(textMap).sort((a, b) => { return +a - (+b); });
		const extraMap = keys.reduce((result, key, index) => {
			if (index > 0) result[key] = this.fillTextTrackGap(textMap[key], startTime, endTime); //缺少数据补全
			return result;
		}, {});
		return {
			textList: this.fillTextTrackGap(textMap[keys[0]], startTime, endTime),  // y最小的一组
			extraMap
		}
	}
	// 补全数据
	fillTextTrackGap(textList = [], startTime = 0, endTime = 0) {
		const newList = textList.reduce((result, obj) => {
			// 前面和中间缺少补全
			const lastEndTime = result[result.length - 1]?.endTime || startTime;
			if (obj.startTime > lastEndTime) {
				result.push({
					text: '',
					startTime: lastEndTime,
					endTime: obj.startTime,
				})
			}
			result.push(obj);
			return result;
		}, [])
		// 末尾补全
		const end_time = newList[newList.length - 1]?.endTime || startTime;
		if (end_time < endTime) {
			newList.push({
				text: '',
				startTime: end_time,
				endTime: endTime,
			})
		}
		return newList;
	}

	/**
	 * 处理文推图方式的数据
	 * @param promptResultVO
	 * @param reGen 
	 */
	reLineTrack(promptResultVO, reGen = false) {
		let promptImageVOList = promptResultVO.promptImageVOList
		let textList = []
		// 特效
		let specialEffectList = []
		promptImageVOList = promptImageVOList.map(ele => {
			let textVOList = ele.textVOList.map((item, idx) => {
				const handleItem = item
				handleItem.startTime = handleItem.startTime / 1000
				handleItem.endTime = handleItem.endTime / 1000
				if (idx === ele.textVOList.length - 1) {
				  handleItem.isEnd = true
				}
				textList.push(handleItem)
				return handleItem
			})
			let specialEffects = ele.specialEffects
			if (specialEffects) {
				specialEffects = specialEffects.map((item) => {
					const handleItem = item
				  handleItem.startTime = ele.startTime / 1000
					handleItem.endTime = ele.endTime / 1000
					specialEffectList.push(item)
					return handleItem
				})
			}
			return {
				...ele,
				textVOList,
				specialEffects
			}
		});
		this.specialEffectList = specialEffectList
		console.log('specialEffectList', this.specialEffectList)
		this.updateTextList(textList, 0)
		this.imgList=[]
		// 传参进行重新生成 或者 第一次生成后path还没有值, 需要重新生成微动转场效果
		const reGenerate = reGen || !!promptImageVOList.find(v => !v.path);
		let needUpdatePrompt = reGenerate;
		promptImageVOList.forEach((item , index) => {
			let slidedirection='right'
			let slideType=''
			let direction = this.getDirectionByPath(item.path); //微动方向，path获取
			const preItem = this.imgList[index - 1];
			const preSlideDirecrion = preItem?.slideType?.split("slide")[1]; // 上一张图片的转场方向
			if(reGenerate) {
				// 转场方向随机
				if(index == 0){
					// 第一张图片都是向右
					slidedirection = 'right'
				}else if (index % 2 === 0) {
					// 角标为偶数，为左右方向
					slidedirection = Math.random() < 0.5 ? 'left' : 'right';
				} else {
					// 角标为奇数，为上下方向
					slidedirection = Math.random() < 0.5 ? 'up' : 'down';
				}
				slideType= 'slide'+ slidedirection

				// 百分之30有转场，没有转场需要使用默认值fade
				if(Math.random() > 0.3){
					slideType = 'fade';
				}
				// 重新生成时，微动方向使用前一张图片的转场（70%被删除）方向
				direction = preItem ? preItem.slidedirection : slidedirection;

				/** 
				 * 以上逻辑分析可得：
				 * 第一张图片的微动是向右，有转场也是向右；
				 * 第二张图片也一定向右微动，有转场定为上/下方向
				 * 从第三张图片开始，奇数时 微动方向是上/下，有转场为左/右；
				 * 从第四张图片开始，偶数时 微动方向是左/右，有转场为上/下；
				 * 如果一张图片有转场，下一张图片的微动方向与其转场方向一致。
				 */
			}
			// 上一张图片有转场，但本张图片的微动方向不对，则需要重新保存
			if(preSlideDirecrion && direction !== preSlideDirecrion) {
				direction = preSlideDirecrion;
				needUpdatePrompt = true;
			}
			// direction = slideType.split("slide")[1]
			let imgItem = {
				startTime: item.startTime / 1000,
				endTime: item.endTime / 1000,
				imgUrl: changeUrl2Cdn(item.imageUrl),
				thumbnailUrl: changeUrl2Cdn(item.thumbnailUrl),
				imageId: item.imageId,
				direction: direction,  // 微动
				slideType:slideType,  // 转场
				slidedirection:slidedirection,
			}
			this.imgList.push(imgItem)
		})
		console.log('imgList',this.imgList);
		this.curSpeakerAudio.audioUrl = this.replaceBgmUrl(promptResultVO.audioUrl)
		let time = this.textList[this.textList.length - 1].endTime
		this.curSpeakerAudio.endTime = time
		this.curSpeakerAudio.startTime = 0
		this.videoDuration = time
		this.imgCoverUrl = this.imgCoverUrl || this.imgList[0].imgUrl
		if (!this.imgPlayer) {
			this.initPlayer()
		} else {
			this.timeAudioPlayer.updateAudioUrl(this.curSpeakerAudio.audioUrl)
		}
		// debugger
		// 重新生成微动转场效果 才调用updatePrompt接口
		if(needUpdatePrompt){
			this.saveJoggingMove()
		}
	}
	imgLoading = false
	imgPlayer = null;
	textPlayer = null;
	vfx: VFX = null;
	timeAudioPlayer = null;
	backAudioPlayer = null;
	trackScrollLeft: number = 0;
	widthEverySecond: number = 0;
	initListener() {
		let trackTimeDom = document.querySelector('.track') as any;
		if(!trackTimeDom){
			return
		}
		trackTimeDom.addEventListener('touchmove', () => {
			if (this.isPlay) {
				this.isPlay = false;
				this.tryAudioPlay(false)
			}
		}, false)
	}
  onTouchStart() {
    this.isPlay = false;
		this.startAudioPlay(false)
  }

	// 手动滚动时更新画布
	updateCanvasOnScrollTrack() {
		const trackTimeDom = this.$refs.trackContainer
		if (!trackTimeDom) {
			// 滚动过程中全屏
			return
		}
		const curTime = this.currPlayTime
		if (!this.isPlay) {
			this.updateRenderEle(curTime)
			if(!this.isIOS){
				this.vfx?.drawVFXByPlay(curTime, true)
			}
		}
		let renderEle = this.getRenderEle(curTime)
		if (renderEle.imgUrl) {
			this.renderEle = renderEle;
		}
		this.getRenderTextEle(curTime)
	}
	// tofix widthEverySecond和物理像素关联，使得targetLeft正好时物理像素整数倍
	// 100 => 1927222
	getTimeByOffset(offset) {
		return Math.round(offset / this.widthEverySecond * 1000_000)
	}
	// 1927222 => 100
	// 1934778 => 100
	getOffsetByTime(time) {
		return Math.round(this.widthEverySecond * time / 1000_000)
	}
	getTimeByTrackScrollOffset() {
		return this.getTimeByOffset(this.trackScrollLeft)
	}
	setTrackScrollOffsetByTime() {
		this.scrollToOffset(this.getOffsetByTime(this.currPlayTime * 1000_000))
	}
	scrollToOffset(offset) {
		// 和dpr关联，大于真实的1px物理像素才会生效 scrollLeft
		// tofix widthEverySecond和物理像素关联，使得targetLeft正好时物理像素整数倍
		const track = this.$refs.trackContainer as HTMLElement
		if (!track) return
		const oldScrollLeft = track.scrollLeft
		track.scrollLeft = offset
		if (track.scrollLeft !== oldScrollLeft) {
			this.isJsScroll = true
		}
	}
	//初始化播放器
	initPlayer() {
		this.imgPlayer = new ImagePlayer(this.imgList, this.errCallback)
		this.imgPlayer.initCallback(this.loadingCallBack)
		// this.textPlayer = new captionsPlayer({ captionsList: this.textList, captionsCallback: this.textPlayerCallback })
		this.$nextTick(() => {
			this.widthEverySecond = this.getWidthEverySecond();
		})
		this.trackScrollLeft = 0
		this.timeAudioPlayer = new audioPlayer({
			audioUrl: this.curSpeakerAudio.audioUrl, on: {
				'error': this.audioEndCallback,
				'ended': this.audioEndCallback,
				'pause': this.audioEndCallback,
				'timeupdate': this.audioPlayCallback,
				'durationchange': () => {
					this.audioDuration = this.timeAudioPlayer.duration
				}
			}
		})
	}
	setShortPlayStyle() {
		const { top, left, width, height } = document.getElementById('videoImgCanvas').getBoundingClientRect()

		console.log('setShortPlayStyle', width)
		this.shortPlayerStyle = {
			top: `${top}px`,
			left: `${left}px`,
			width: `${width}px`,
			height: `${height}px`,
			clientWidth: width,
			clientHeight: height,
		};
	}
	// 初始化短剧播放器
	initShortPlay() {
		this.setShortPlayStyle();
		this.timeSegmentPlayer = new SegmentPlayer({
			segments: this.segmentsList, 
			canvasRef: this.shortPlayerStyle,
			on: {
				timeupdate: this.segmentPlayCallback,
				error: this.audioEndCallback,
				ended: this.audioEndCallback,
				changeSegment: this.segmentChangeCallback,
				subtitlesEdit: this.subtitlesEditCallback,
				subtitlesChange: this.subtitlesChangeCallback,
				changeLoading: this.changeLoading,
			}
		})
		// 监听播放器初始化完成，关闭页面loading
		this.timeSegmentPlayer.initCallback(() => {
			this.showloading = false;
		})
		this.$bus.$on('doClickVideoEditor', () => {
			if(!this.isOncePlay) {
				this.isOncePlay = true;
				if(!this.isPlay && this.currPlayTime === 0) {
					console.log('doClickVideoEditor')
					this.timeSegmentPlayer?.tryPlayFirstVideo();
				}
			}
		});
		this.$nextTick(() => {
			this.widthEverySecond = this.getWidthEverySecond();
		})
		this.trackScrollLeft = 0
	}
	changeLoading(bol = false) {
		this.showloading = bol;
	}
	segmentPlayDiffRatio = 1; // 短剧段落播放时，与实际播放时间差值比例，用来做滚动速度控制
	// 监听短剧段落切换
	segmentChangeCallback() {
		this.segmentPlayDiffRatio = 1;
		const activeSegment = this.timeSegmentPlayer.activeSegment;
		const maxSrollleft = this.getOffsetByTime(activeSegment.endTime * 1000_000);
		this.updateUIByRaf(maxSrollleft);
	}
	decompressSegmentChangeCallback() {
		console.log('decompressSegmentChangeCallback')
		// this.segmentPlayDiffRatio = 1;
		// const activeSegment = this.timeDecompressPlayer.activeSegment;
		// const maxSrollleft = this.getOffsetByTime(activeSegment.endTime * 1000_000);
		// this.updateUIByRaf(maxSrollleft);
	}
	// 监听短剧段落播放
	segmentPlayCallback(time, activeSegment) {
		this.currPlayTime = time;
		this.renderBlurTime = time;
		// 解说段播放背景音
		if(this.backAudioPlayer) {
			if(activeSegment?.type === 'explanation') {
				if(this.backAudioPlayer.paused) this.backAudioPlayer.play(time - activeSegment.startTime);
			} else {
				this.backAudioPlayer.pause()
			}
		}
	}

	// 判断轨道的滚动是/否结束
	isScrollFinish = true

	onTrackScroll() {
		const track = this.$refs.trackContainer as HTMLElement
		if (!track) return;
		this.isScrollFinish = false
		this.trackScrollLeft = track.scrollLeft
		if (this.timeAudioPlayer?.paused && !this.isJsScroll) {
			// 播放过程中，不根据滚动距离更新时间
			this.seekTimeByScrollTrack()
		} else if (this.timeSegmentPlayer?.paused && !this.isJsScroll) {
			this.seekTimeByScrollTrack()
		} else if (this.timeDecompressPlayer?.paused && !this.isJsScroll) {
			this.seekTimeByScrollTrack()
		}
		this.debouncedOnTrackScroll({
			isJsScroll: this.isJsScroll
		})
		this.isJsScroll = false
		this.$bus.$emit(this.$EventBusKey.TRACK_SCROLL)
	}
	debouncedOnTrackScroll = debounce(function ({
		isJsScroll
	}) {
		// 滚动结束
		this.isScrollFinish = true
		if (this.timeAudioPlayer?.paused && !isJsScroll) {
			// 播放过程中，滚动不更新画布，画布更新由timeupdate驱动
			this.updateCanvasOnScrollTrack()
		} else if (this.timeSegmentPlayer?.paused && !isJsScroll) {
			// 更新画面
			this.updateCanvasOnScrollTrack()
		} else if (this.timeDecompressPlayer?.paused && !isJsScroll) {
			this.updateCanvasOnScrollTrack()
		}
	}, 500)
	
	updateUIRafId = null;
	updateUIByRaf(maxSrollleft = 0) {
		let lastATime = Math.round(this.currPlayTime * 1000_000); // 音频时钟 微秒
		let lastUiTime = lastATime; // UI更新时钟 微秒
		let lastGTime = this.getNow(); // 系统时钟 微秒
		let timeupdateTimes = 0
		let speed = this.widthEverySecond / 1000_000
		let offset = 0
		let blockTime = 0
		const scrollBySpeed = (deltaT) => {
			offset = offset + speed * deltaT * this.segmentPlayDiffRatio
			// 设置最大滚动位置，滚到对应位置后暂停
			if(maxSrollleft && offset > maxSrollleft) {
				offset = maxSrollleft;
			}
			console.log('scrollBySpeed')
			this.scrollToOffset(offset)
			// 滚动速度控制
			const curTimeOffset = this.getOffsetByTime(this.currPlayTime * 1000_000);
			if(offset - curTimeOffset > 20) {
				this.segmentPlayDiffRatio = 0.1; // 滚动快了，减速滚动
			} else if(curTimeOffset - offset > 20) {
				this.segmentPlayDiffRatio = 2; // 滚动慢了，加速滚动
			} else {
				this.segmentPlayDiffRatio = 1
			}
			// const diff = this.getTimeByTrackScrollOffset() / 1000_000 - this.currPlayTime;
			// if(diff > 0.5)  {
			// 	console.log('diff', diff)
			// 	this.startAudioPlay(true); // 滚动对应时间比播放时间超前0.5s以上，播放到滚动条位置
			// 	this.updateUIByRaf(); // 滚动条回退
			// }
		}
		const scrollToTime = (time) => {
			offset = this.getOffsetByTime(time)
			this.scrollToOffset(offset)
		}

		const auto = () => {
			this.stopUpdateUIByRaf()
			if (this.isPlay) {

				this.updateUIRafId = requestAnimationFrame(auto)
				const cTime = this.currPlayTime
				const aTime = Math.round(cTime * 1000_000)
				const isTimeupdate = aTime !== lastATime // 音频时间更新了，需要校准一次滚动条，ios会出现时间回退300ms的问题
				if (isTimeupdate) {
					timeupdateTimes++
				}

				const threshold = 1000_000

				lastATime = aTime

				const now = this.getNow()
				const gDiffTime = now - lastGTime
				lastGTime = now
				const uiTime = lastUiTime + gDiffTime
				if (isTimeupdate) {
					if (timeupdateTimes === 1) {
						// 第一次更新aTime

						// 直接滚动到对应位置
						scrollToTime(aTime)
						lastUiTime = aTime
					} else {
						// 后续更新aTime
						if (Math.abs(uiTime - aTime) < threshold) {
							// 1s偏差，认为UI更新和音频同步
							// 匀速滚动
							scrollBySpeed(gDiffTime)
							lastUiTime = uiTime

							blockTime = 0
						} else if (uiTime < aTime) {
							// 音频加速了，UI追赶音频
							scrollToTime(aTime)
							lastUiTime = aTime

							blockTime = 0
						} else if (uiTime > aTime) {
							// 音频阻塞了，UI等待音频
							blockTime = uiTime - aTime // 阻塞一段时间后接着跑
						}
					}
				} else if (timeupdateTimes > 0 && blockTime === 0) {
					// 未更新aTime
					// 匀速滚动
					scrollBySpeed(gDiffTime)
					lastUiTime = uiTime
				} else {
					blockTime = Math.max(0, blockTime - gDiffTime)
				}
			}
		}

		scrollToTime(lastATime) // 滚动到对应位置
		this.stopUpdateUIByRaf()
		this.updateUIRafId = requestAnimationFrame(auto)
	}

	stopUpdateUIByRaf() {
		cancelAnimationFrame(this.updateUIRafId)
	}

	getNow = window.performance?.now ? () => {
		return Math.round(performance.now() * 1000)
	} : () => {
		return Date.now() * 1000
	}
	loadingCallBack() {
		this.showloading = false;
		(this.$refs.subtitlesRef as any).initLayout()
		const videoCanvasRef = this.$refs.videoCanvasRef as any
		this.vfx = new VFX(videoCanvasRef, this.specialEffectList)
	}

	startCallback() {
		this.imgLoading = false
		this.isPlay = true
		if (this.backAudioPlayer) {
			this.backAudioPlayer.play(this.currPlayTime)
		}
	}
	/**
	 * 更新指针位置
	 */
	updatePosition() {
		const selectIndex = this.curSelect.selectIndex
		const textInfo = this.textList[selectIndex]
		const startOffset = this.getOffsetByTime(textInfo.startTime * 1000_000)
		const endOffset = this.getOffsetByTime(textInfo.endTime * 1000_000)
		const trackContainerRef = this.$refs.trackContainer as HTMLElement;
		if (trackContainerRef.scrollLeft >= startOffset && trackContainerRef.scrollLeft <= endOffset) return
		const diff = (textInfo.endTime - textInfo.startTime) / 2
		this.textClick(textInfo, selectIndex)
		this.manualSeekTime((textInfo.startTime + diff) * 1000_000)
		this.setTrackScrollOffsetByTime()
	}
	//初始化背景音乐
	initBackAudio() {
		this.backAudioPlayer = new backgroundAudioPlayer({ audioUrl: this.backAudio.audioUrl, endCallback: this.audioEndCallback, audioDuration: this.backAudio.duration, volume: this.bgVolume / 100 })
	}
	//获取当前显示的图片和字幕
	getRenderEle(time) {
		//过滤imgList找到第一个startTime或者endTime大于time的值
		let imgEle = this.imgList.filter((ele) => {
			return ele.startTime >= time || ele.endTime > time
		})
		let textEle = this.textList.filter((ele, idx) => {
			return ele.startTime >= time || ele.endTime > time
		})
		const index = this.textList.findIndex(ele => ele.startTime >= time || ele.endTime > time)
		let renderEle = {
			imageId: imgEle[0]?.imageId,
			imgUrl: imgEle[0]?.imgUrl,
			text: textEle[0]?.text,
			index
		}
		return renderEle

	}
	getRenderTextEle(time) {
		let textEle = this.textList.filter((ele) => {
			return ele.endTime >= time && ele.startTime <= time
		})
		if (!textEle || !textEle.length) {
			return {
				text: '',
				index: -1
			}
		}
		let index = this.textList.findIndex(ele => ele.imageId === textEle[0].imageId)
		this._scrollCurIndex = this.textList.findIndex(ele => ele.imageId === textEle[0].imageId && textEle[0].endTime === ele.endTime && textEle[0].startTime === ele.startTime)
		this.currentItem = textEle[0]
		return {
			text: textEle[0]?.text,
			index:index
		}
	}
	/**
	 * 更新当前选择
	 */
	updateSelectText() {
		const item = this.textList[this._scrollCurIndex]
		if (item) {
			this.textClick(item, this._scrollCurIndex)
		}
		this.startAudioPlay(false)
	}
	//编辑字幕
	editorSubtitle() {
		this.isEdit = true
    this._scrollCurIndex = this._scrollCurIndex || 0
		console.log('editorSubtitle', this._scrollCurIndex)
		this.updateSelectText()
    const _rcList = this.ttsWordVOList.filter(item => item.sentenceIndex === this._scrollCurIndex)
		this.$emit('editor-subtitle', {...this.renderEle, index: this._scrollCurIndex, rcttsWordList: _rcList})
	}
	// 获取短剧转图片
	async getRenderImageBlob() {
		const blob = await this.timeSegmentPlayer?.toImageBlob();
		this.$bus.$emit('setCoverImageBlob', blob);
	}
	//更新显示的图片和字幕
	updateRenderEle(curTime) {
		// todo 短剧
		if(this.isShortPlay) {
			this.timeSegmentPlayer.show(curTime);
			// 高斯模糊时间显示
			this.renderBlurTime = curTime;
			return;
		}
		let ele = this.getRenderEle(curTime)
		if (this.isDownStress && ele) {
			this.renderEle = ele
			this.timeDecompressPlayer.show(curTime)
			this.renderBlurTime = curTime
			return
		}
		if (ele.imgUrl && (!this.renderEle.imgUrl || ele.imgUrl != this.renderEle.imgUrl)) {
			this.imgPlayer.drawImageByTime(curTime)
			this.renderEle = ele
		}
	}
	//更新显示的图片及dom
	renderImg() {
		if(this.isShortPlay) return;
		this.imgPlayer.upadateCanvasDom()
		this.imgPlayer.drawImageByUrl(this.renderEle.imgUrl)
	}
	//尝试播放
	tryAudioPlay(type) {
		if (this.isShortPlay || this.isDownStress) {
			this.startAudioPlay(type);
			return;
		}

		if(this.imgLoading){
			return toast('正在合成音频，请稍后操作')
		}
		if (!this.isCanReAudio) {
			this.startAudioPlay(type)
		} else {
			this.reCreateAudio().then(async (res) => {
				this.updateTTSWordList()
			
				try {
					await this.saveVideoPromot()
				} catch (error) {
					
				}
				// 重新初始化 ImagePlayer
				this.imgPlayer = new ImagePlayer(this.imgList, this.errCallback)
				this.vfx = new VFX(this.$refs.videoCanvasRef, this.specialEffectList);
				const imgIndex = this.imgList.findIndex(ele => ele.imageId === this.currentItem.imageId)
				if (imgIndex > -1) {
					this.imgPlayer.drawIndexImage(imgIndex)
					const time = this.timeAudioPlayer.currentTime
					if (!this.isIOS && !this.isScreen) {
						this.vfx.drawVFXByPlay(time)
					}
				}
				this.isCanReAudio = false
				if(this.isSupport){
					this.startAudioPlay(type)
				}
			
			}).catch((error) => {
				this.isCanReAudio = true
				// this.startAudioPlay(type)
				this.$toast('音频合成失败，请稍后再试')
			})

		}
	}
	/**
	 * 配音后重新分局更新索引
	 */
	updateTTSWordList() {
	  this.textList.forEach((item, index) => {
		  if (index > 0 && item.index === index - 1 && this.ttsWordVOList.length > 0) {
			  let preWordIndex:any
			  const list = []
			  Array.from(item.text).forEach(word => {
				  this.ttsWordVOList.forEach((wordInfo, idx) => {
					  if (wordInfo.word === word && wordInfo.sentenceIndex === item.index) {
						  this.ttsWordVOList.splice(idx, 1)
						  wordInfo.idx = idx
						  list.push(wordInfo)
						  if ((idx - preWordIndex) > 1) {
						  	list.splice(idx, 1)
						  	if (list.length) {
						  		this.ttsWordVOList.splice(list[0].idx, list.length)
						  	}
						  }
						  preWordIndex = idx
					  }
				  })
			  })
		   }
	  })
	}
	playSegmentsList(type) {
		if(type) {
			this.isPlay = true;
			if(!this.isScreen && !this.isShowGeneratePickture){
				this.seekTimeByScrollTrack() // 由于播放时自动滚动可能会和实际音视频有偏差
			}
			// 播放到视频结束再次播放
			if (this.currPlayTime >= this.shortDuration - 0.2) {
				this.scrollToOffset(0)
				this.currPlayTime = 0;
				this.renderBlurTime = 0;
			}

			const activeSegment = this.timeSegmentPlayer.activeSegment;
			const maxSrollleft = this.getOffsetByTime(activeSegment.endTime * 1000_000);
			this.updateUIByRaf(maxSrollleft);
			this.timeSegmentPlayer.play(this.currPlayTime);
			if(!this.isIOS) {
				// 安卓手机需要在用户点击时检查播放器
				this.timeSegmentPlayer.checkPlay();
			}
			// 解说段播放背景音
			if(this.backAudioPlayer && activeSegment?.type === 'explanation') {
				this.backAudioPlayer.play(this.currPlayTime - activeSegment.startTime);
			}
			console.log('playSegmentsList', this.currPlayTime, activeSegment);
		} else {
			this.isPlay = false;
			this.timeSegmentPlayer.pause();
			if (this.backAudioPlayer) {
				this.backAudioPlayer.pause();
			}
		}
	}
	async startAudioPlay(type) {
		console.log('startAudioPlay', type);
		if (this.isShortPlay) {
			this.playSegmentsList(type);
			return;
		}
		if (this.isDownStress) {
			if (type) {
				if(this.imgLoading){
					return toast('正在合成音频，请稍后操作')
				}
				if (!this.isCanReAudio) {
					this.playDownStress()
				} else {
					this.reCreateAudio().then(async (res) => {
						this.updateTTSWordList()
					
						try {
							await this.saveVideoPromot()
						} catch (error) {
							
						}
						this.isCanReAudio = false
						this.playDownStress()
					
					}).catch((error) => {
						this.isCanReAudio = true
						// this.startAudioPlay(type)
						this.$toast('音频合成失败，请稍后再试')
					})
				}
				
			} else {
				this.stopPlayDownStress()
			}
			return
		}
		if (type) {
			this.$emit('to-home-tab')
			this.isPlay = true
			if(!this.isScreen && !this.isShowGeneratePickture){
				this.seekTimeByScrollTrack() // 由于播放时自动滚动可能会和实际音频有偏差，播放时按照滚动的位置重置下音频开始时间。可能会出现暂停后，继续播放有一定偏差的情况。
			}
			if (typeof this.audioDuration === 'number' ? this.currPlayTime >= this.audioDuration - 0.2 : this.currPlayTime >= this.videoDuration - 0.2) {
				// 优先和音频时长比较。减去0.2s:因为现在 由滚动距离=>时间 和时间=>滚动距离 不是精确的逆运算
				// 音频时长没获取到，则与视频时长比较，减去0.2s:因为视频时长和实际音频时长有毫秒级的差距。
				this.scrollToOffset(0)
				this.currPlayTime = 0;
			}
	
			this.$bus.$emit(this.$EventBusKey.CANVASPLAY)
			this.updateUIByRaf()
			this.timeAudioPlayer.play(this.currPlayTime)
			this.imgPlayer.start()
			this.startCallback()
			if (!this.backAudioPlayer && this.backAudio.audioUrl) {
				this.initBackAudio()
			}
			if(!this.isIOS){
				this.vfx.play()
			}
		} else {
			this.stopAudio()
		}
	}
	/**
	 * 播放解压视频
	 */
	playDownStress() {
		if(!this.isScreen && !this.isShowGeneratePickture){
			this.seekTimeByScrollTrack() // 由于播放时自动滚动可能会和实际音视频有偏差
		}
		if (typeof this.audioDuration === 'number' ? this.currPlayTime >= this.audioDuration - 0.2 : this.currPlayTime >= this.videoDuration - 0.2) {
			// 优先和音频时长比较。减去0.2s:因为现在 由滚动距离=>时间 和时间=>滚动距离 不是精确的逆运算
			// 音频时长没获取到，则与视频时长比较，减去0.2s:因为视频时长和实际音频时长有毫秒级的差距。
			this.scrollToOffset(0)
			this.currPlayTime = 0
		}
		this.updateUIByRaf()
		this.timeDecompressPlayer.play(this.currPlayTime)
		this.backAudioPlayer.play(this.currPlayTime)
		if(!this.isIOS) {
			// 安卓手机需要在用户点击时检查播放器
			this.timeDecompressPlayer.checkPlay();
		}
		this.isPlay = true
	}
	/**
	 * 停止解压视频
	 */
	stopPlayDownStress() {
		if (this.backAudioPlayer) {
			this.backAudioPlayer.pause()
		}
		if (!this.timeDecompressPlayer) return
		this.timeDecompressPlayer.pause()
		this.isPlay = false
	}
	/**
	 * 停止播放
	 */
	stopAudio() {
		if (this.state.workType === 'down_stress') {
			this.stopPlayDownStress()
		} else {
			if(!this.isIOS && !this.isDownStress){
				this.vfx.stop()
			}
			// debugger
			this.isPlay = false
			this.imgPlayer.pause()
			// this.textPlayer.pause()
			this.timeAudioPlayer.pause()
			if (this.backAudioPlayer) {
				this.backAudioPlayer.pause()
			}
		}
		
	}
	/**
	 * 显示封面弹窗
	 */
	showCoverPopup() {
		this.showCover = true
	}
	selectImg(e) {
		let file = e.target.files[0]
		let imgForm = new FormData()
		imgForm.append('file', file)
		//文件上传
		let uploadUrl = 'https://tts-files.mobvoi.com/v1/file/uploadToOss'

		Axios.post(uploadUrl, imgForm, {
			headers: { 'Content-Type': 'multipart/form-data' },
			timeout: 1000 * 60 * 30 // 设置30分钟超时
		}).then(res => {
			if (res.status != 200 || res.data.code !== 200 || !res.data.data) {
				return toast('图片上传失败')
			}
			this.imgCoverUrl = res.data.data
			this.saveVideoPromot()
		})
		this.startAudioPlay(false)

	}
	textClick(item, index, type: selectType = 'text') {
		if (!this.isScrollFinish) return
		this.curSelect = {
			type: type,
			selectIndex: index
		}
		this.currentItem = item
		this.renderEleIndex = index
		this._scrollCurIndex = index
		this.updateRenderEle(item.startTime)
		let renderEle = this.getRenderEle(item.startTime)
		if(this.isShortPlay) renderEle = item;
		this.renderEle = renderEle;
		if(this.isShortPlay) {
			// 设置选中字幕uuid
			this.isEdit = true;
			this.uuidSelectedText = item.uuid;
		} else {
		this.isEdit = true
    const _rcList = this.ttsWordVOList.filter(item => item.sentenceIndex === index)
		this.$emit('change-tab-list', {
			type: TabBarListTypeMap.FONT,
			param: renderEle,
			index,
      rcttsWordList: _rcList
		})
		}
		this.startAudioPlay(false)
	}
	//文字全量更新
	updateTextList(textList, index) {
		this.textList = textList
		this.renderEle.text = this.textList[index].text
		this.uuidSelectedText = this.textList[index].uuid || '';
		this.isCanReAudio = true
	}
	//图片全量更新
	updateImgList(imgList, index = -1, type?: string) {
		this.imgList = imgList
		this.imgPlayer && this.imgPlayer.updateImgList(imgList)
		if (type !== 'completeGenerate') {
			this.isCanReAudio = true
		}
		// this.renderEle.imgUrl = this.imgList[index].imgUrl // 不应该加，后续要比较图片url
		if (this.imgList[index]) {
			this.updateRenderEle(this.imgList[index].startTime)
		}
	}
	/**
	 * 更新当前发音人信息
	 * @param speakerInfo
	 */
	updateSpeakerAudio(speakerInfo) {
		speakerInfo.name && (this.curSpeakerAudio.speakerName = speakerInfo.name)
		const speakerEmotionCacheVOList = speakerInfo.speakerEmotionCacheVOList
		if (speakerEmotionCacheVOList) {
			let info = speakerEmotionCacheVOList.find(item => item.moodName === '默认')
			if (!info) return
			speakerInfo.speaker = info.speaker
			speakerInfo.style = info.moodName
		}
		this.curSpeakerAudio={
			...this.curSpeakerAudio,
			speakerName: speakerInfo.name,
			speed: speakerInfo.speed,
			style: speakerInfo.style,
			speaker: speakerInfo.speaker,
		}
		this.isCanReAudio = true
	}
	/**
	 * 更新当前发音人信息
	 * @param speakerInfo
	 */
	updateBackAudio(audioInfo) {
    console.log('player updateBackAudio', audioInfo)
		this.backAudio = {
			audioUrl: audioInfo.audioUrl,
			audioName: audioInfo.audioName,
			duration: audioInfo.duration,
		}
		if (!this.backAudioPlayer) {
			this.initBackAudio()
		} else {
			this.backAudioPlayer.updateAudioUrl(this.backAudio)
		}
	}
	/**
	 * 编辑字幕
	 * @param params
	 * @param text 
	 */
	updateSubtitles(text) {
		if(this.isShortPlay) {
			// 暂不支持修改字幕文本
			// const { type: textType, selectIndex } = this.curSelect;
			// let textList = [];
			// if(textType === 'text') {
			// 	textList = this.textList;
			// } else {
			// 	textList = this.extraTextMap[textType.replace('text', '')] || [];
			// }
			// if(textList[selectIndex]) {
			// 	textList[selectIndex].text = text;
			// 	this.state.subtitleInfo.textList = textList;
			// }
			return;
		}
		this.renderEle.text = text
		this.textList[this.renderEleIndex].text = text
		this.renderEle.text = this.textList[this.renderEleIndex].text
		this.isCanReAudio = true
		this.state.subtitleInfo.textList = this.textList
		const _rcList = this.ttsWordVOList.filter(item => item.sentenceIndex === this.renderEleIndex)
		this.$emit('change-tab-list', {
			type: TabBarListTypeMap.FONT,
			param: this.renderEle,
			index: this.renderEleIndex,
      rcttsWordList: _rcList
		})
	}
	trackImgClick(item, index, updateCurrTime = false) {
		if (!this.isScrollFinish) return
		// 绿幕视频不支持编辑图片
		if(this.isGreenScreen) return;
		this.curSelect = {
			type: 'img',
			selectIndex: index
		}
		this.renderEleIndex = index
		this.currentItem = item
		// this.imgPlayer.drawIndexImage(index)

		this.updateRenderEle(item.startTime)
		let renderEle = this.getRenderEle(item.startTime)
		if(!this.isShortPlay && !this.isDownStress) { // 短剧和解压视频暂时不支持图片编辑
			this.$emit('change-tab-list', {
				type: TabBarListTypeMap.IMG,
				param: renderEle,
				index
			})
		}
		this.startAudioPlay(false)
		if(updateCurrTime) {
			// 图片编辑页时点击图片，需要更新为当前时间
			this.manualSeekTime(item.startTime * 1000_000);
		}
	}
	exchangeData = null
	trackBackAudioClick() {
		this.curSelect = {
			type: 'backAudio',
			selectIndex: -1
		}
		this.$emit('change-tab-list', {
			type: TabBarListTypeMap.BGMUSIC,
			param: this.backAudio
		})
	}
	// 没有背景音乐跳转去选择
	trackAudioClick(params) {
		// this.$emit('change-tab', TabTypeMap.MUSIC, params)
		this.$emit('change-tab-list', {
			type: TabBarListTypeMap.BGMUSIC,
			param: params,
		})
	}
	trackSpeakerClick() {
		if(this.isShortPlay) {
			// 暂时不能编辑发音人
			toast('暂时不能编辑');
			return;
		}
		this.curSelect = {
			type: 'speakerAudio',
			selectIndex: -1
		}
		this.$emit('change-tab-list', {
			type: TabBarListTypeMap.SPEAKER,
			param: this.curSpeakerAudio
		})
		this.$emit('changeSpeakerInfo', this.curSpeakerAudio)
	}
	showGeneratePickture() {
		this.isShowGeneratePickture = true;
    this.orginalImgList = JSON.parse(JSON.stringify(this.imgList))
		this.$nextTick(() => {
			(this.$refs.subtitlesRef as any).initLayout()
		})
	}
  closeGenerate() {
    this.isShowGeneratePickture = false;
    this.orginalImgList = [];
		this.$nextTick(() => {
			(this.$refs.subtitlesRef as any).initLayout()
		})
  }
  /**
   * 重置
   */
  resetGenerate() {
    const generateRef = this.$refs.generateRef as any;
    const index = generateRef.activeGalleryItemIndex
    this.updateImgList(this.orginalImgList, index);
		generateRef.reset();
  }
	/**
	 * 使用生图/微调
	 */
	completeGenerate(imgList, index, obj = null) {
		// this.canvasHeight = 0.72
		if (imgList && imgList.length) {
			// 没有点勾号，只把图片显示修改，不存储快照
			this.updateImgList(imgList, index, 'completeGenerate')
			if(obj) {
				// 设置的exchangeData会存储到这次快照中
				this.exchangeData = obj
				this.saveProject()
			}
		}
		
	}
	/**
   * 隐藏编辑框
   */
	hideEdit() {
		if (!this.isDownStress) {
			this.isEdit = false
		}
	}
	/**
	 * 撤销
	 */
	undoProject() {
		this.checkPlay()
		if (this.projectHistory.canUndo()) {
			this.isCanReAudio = true
		}
		this.exchangeImage(true); // 取cmdPos调换前的这一条的列表
		this.projectHistory.undoProjectDataFromStorage()
		this.renderProjectData()
		this.canUndo = this.projectHistory.canUndo()
		this.canRedo = this.projectHistory.canRedo()
	}
	/**
	 * 回退
	 */
	redoProject() {
		this.checkPlay()
		if (this.projectHistory.canRedo()) {
			this.isCanReAudio = true
		}
		this.projectHistory.redoProjectDataFromStorage()
		this.exchangeImage(false); // 取cmdPos调换后的这一条的列表
		this.renderProjectData()
		this.canUndo = this.projectHistory.canUndo()
		this.canRedo = this.projectHistory.canRedo()
	}
	checkPlay() {
		if (this.isPlay) {
			this.tryAudioPlay(false)
		}
	}
	renderProjectData() {
		const projectData = this.projectHistory.getCurrentProjectDataFromStorage()
		if(this.isShortPlay) {
			// 短剧撤销回退
			this.backAudio = projectData.backAudio;
			this.bgVolume = projectData.bgVolume;
			this.imgCoverUrl = projectData.imgCoverUrl;
			this.coverMaterialList = projectData.coverMaterialList;
			// this.segmentsList = projectData.segmentsList;
			// this.shortCut = projectData.shortCut;
			this.changeBgVolume(this.bgVolume);
			this.$emit("update-bgVolume", this.bgVolume / 100);
			this.backAudioPlayer.updateAudioUrl(this.backAudio);
			debouncedSaveArticle(this);
			return;
		}
		this.state.subtitleInfo = {
			...projectData.subtitleInfo,
			type: 2
		}
		this.backAudio = projectData.backAudio
		this.textList = projectData.textList
		this.imgList = projectData.imgList
		// this.renderEle = projectData.renderEle
		this.bgVolume = projectData.bgVolume
		this.imgCoverUrl = projectData.imgCoverUrl
		this.changeBgVolume(this.bgVolume)
		this.$emit("update-bgVolume", this.bgVolume / 100)
		if (projectData.curSpeakerAudio) {
			this.curSpeakerAudio = projectData.curSpeakerAudio
		}
		this.backAudioPlayer.updateAudioUrl(this.backAudio)
		
		// if (this.currentItem && this.currentItem.imageId && this.curSelect.type === 'text') {
		// 	this.textClick(this.currentItem, this.curSelect.selectIndex)
		// }
		if (projectData.ttsWordVOList) {
			this.ttsWordVOList = projectData.ttsWordVOList
		}
		this.$bus.$emit(this.$EventBusKey.CHANGE_STYLE_CONTENT)
		this.$bus.$emit(this.$EventBusKey.CHANGE_STYLE_FONTFAMILY)
		this.$emit('changeSpeakerInfo', this.curSpeakerAudio)
		debouncedSaveArticle(this)
	}
	exchangeImage(isUndo) {
		const exchangeData = this.projectHistory.getCurrentProjectDataFromStorage().exchangeData;
		if(!exchangeData?.length) return;
		// 撤销，把刚刚进行的图片操作反向；回退，把之前执行的图片操作再执行一次
		const resetExchangeList = isUndo ? exchangeData.map(item => {
			return {
				currentImageId: item.currentImageId,
				targetImgUrl: item.originImgUrl,
				targetThumbnailUrl: item.originThumbnailUrl,
			}
		}) : exchangeData;
		this.$http('batchExchangeImage', {
			taskId: this.taskId,
			imgExchangeList: resetExchangeList
		}).then((res) => {
      if (res.code === 200) {
        const imgList = this.imgList
        const promptImageVOList = res.data.promptImageVOList
        imgList.map((item, i) => {
          const info = promptImageVOList[i];
          item.imgUrl = info.imageUrl;
          item.thumbnailUrl = info.thumbnailUrl;
					return item;
        })
        console.log('completeGenerate', res.data.promptImageVOList)
        // this.changeGallery(imgList[this.activeGalleryItemIndex], this.activeGalleryItemIndex)
				const { type, selectIndex} = this.curSelect;
				this.updateImgList(imgList, type === 'img' ? selectIndex : -1);
      } else {
        this.$toast(res.message || '图片修改失败');
      }
    })
	}

	// 是否显示反馈按钮，app需要1.1.5以上版本
	get isShowFeedback() {
		return !this.imgLoading && !this.isPlay && !this.showCover 
			&& (!this.isApp || this.$store.state.appVersion >= '1.1.5');
	}
	// 反馈
	doFeedback() {
		const params = {
			type: 'IMAGE',
			image_id: this.renderEle.imageId,
			article_id: this.articleId,
		};
		let url = `/mine-package/pages/feedback/feedback`;
		if(this.isShortPlay) {
			url = `/mine-package/pages/feedback-question/feedback-question`;
			params.type='OTHER';
			delete params.image_id;
		}
		if(this.isApp) {
			const switchToFeedback: any = (<any>window).switchToFeedback;
      switchToFeedback.postMessage(JSON.stringify(params));
			return;
		}
		url = `${url}?${Object.keys(params).map(key => `${key}=${params[key]}`).join('&')}`;
		this.$navigateTo({
			url,
		})
	}

	/****************************** 文字模板 ******************************/

	/** 编辑文本轨道 */
	handleEditTextTrack(index) {
		this.curSelect = {
			type: 'textTemplate',
			selectIndex: -1
		}
		this.state.operatingTextIndex = index
		this.state.operatingTextContent.text = this.state.operatingTextList[index]?.text || ''
		this.$emit('change-tab-list', {
			type: TabBarListTypeMap.TEXT_TEMPLATE,
			param: {
				...this.state.operatingTextContent,
				source: 'text_template'
			}
		})
	}

	/** 添加新的文本轨道 */
	handleAddTextTrack() {
		this.state.operatingTextIndex = null
		this.$emit('change-tab-list', {
			type: TabBarListTypeMap.TEXT_TEMPLATE,
			param: {
				...this.state.operatingTextContent,
				source: 'text_template'
			}
		})
	}

  // 正在编辑文字模板
  isEditingTextTemplate: boolean = false

  /** 修改文字模板编辑状态 */
  changeTextTemplateEditState(visible: boolean) {
    this.isEditingTextTemplate = visible
  }

	/****************************** 背景音替换被删除的域名 ******************************/

	replaceBgmUrl(url = '') {
		if (!url) return ''
		const needReplaceUrls = ['https://mobvoi-speech-public.mobvoi.com/']
		needReplaceUrls.forEach(item => {
			if (url.includes(item)) {
				url = url.replace(item, 'https://tc-nj-speech-pub-cdn.mobvoi.com/')
			}
		})
		return url
	}
	
}

